
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("C9t7g", function(module, exports) {

$parcel$export(module.exports, "PLATFORM_MENU_ID_PREFIX", () => $7b79f828379224e7$export$311d3c02bd72bcc0);
$parcel$export(module.exports, "GlobalNavigationComponent", () => $7b79f828379224e7$export$f83d6aa785dd4970);
$parcel$export(module.exports, "updateNavigationCustomization", () => $7b79f828379224e7$export$94a5e0cf2e657dff);

var $gwFzn = parcelRequire("gwFzn");

var $j1Ss3 = parcelRequire("j1Ss3");

var $d2LG0 = parcelRequire("d2LG0");

var $inPa6 = parcelRequire("inPa6");

var $5izcQ = parcelRequire("5izcQ");

var $9kbAI = parcelRequire("9kbAI");

var $034wI = parcelRequire("034wI");
var $bnGHl = parcelRequire("bnGHl");

var $dIouf = parcelRequire("dIouf");

var $d9tcB = parcelRequire("d9tcB");
var $bQm3c = parcelRequire("bQm3c");

var $dPJCf = parcelRequire("dPJCf");

var $epLE5 = parcelRequire("epLE5");

var $jmjWc = parcelRequire("jmjWc");

var $gKr8t = parcelRequire("gKr8t");

var $9wGTI = parcelRequire("9wGTI");

var $b8XTE = parcelRequire("b8XTE");

var $6adZX = parcelRequire("6adZX");

var $1uFsv = parcelRequire("1uFsv");

var $2usLc = parcelRequire("2usLc");

var $6bH0k = parcelRequire("6bH0k");

var $blzId = parcelRequire("blzId");

var $hwR8R = parcelRequire("hwR8R");

var $3z2Im = parcelRequire("3z2Im");

const $7b79f828379224e7$var$CustomizationModalLoader = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "Vj9xc",
    name: "CustomizationModalLoader",
    loader: async ()=>{
        const { CustomizationModalComponent: CustomizationModalComponent } = await (parcelRequire("a2g1f"));
        return CustomizationModalComponent;
    }
});

const $7b79f828379224e7$var$CustomizeSidebarDialogLoader = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "pfBp0",
    name: "CustomizeSidebarDialogLoader",
    loader: async ()=>{
        const { CustomizeSidebarDialog: CustomizeSidebarDialog } = await (parcelRequire("f7Mww"));
        return CustomizeSidebarDialog;
    }
});
const $7b79f828379224e7$export$311d3c02bd72bcc0 = 'confluence.sidebar.';

const $7b79f828379224e7$var$useLazyClickAnalytics = (0, $epLE5.createLazyCallbackHook)(async ()=>(await (parcelRequire("gtSas"))).fireMoreMenuClickedAnalytics);
const $7b79f828379224e7$var$hasAccess = (accessStatus)=>![
        (0, $d9tcB.AccessStatus).ANONYMOUS_ACCESS,
        (0, $d9tcB.AccessStatus).UNLICENSED_AUTHENTICATED_ACCESS,
        null
    ].includes(accessStatus);
const $7b79f828379224e7$export$f83d6aa785dd4970 = ({ productSideNavigation: productSideNavigation, isOnAnySettingsScreen: isOnAnySettingsScreen })=>{
    const { accessStatus: accessStatus, cloudId: cloudId, userId: userId, activationId: activationId } = (0, $bQm3c.useSessionData)();
    const [peekingId, setPeekingId] = (0, $gwFzn.useState)(undefined);
    const [isMoreMenuOpen, setIsMoreMenuOpen] = (0, $gwFzn.useState)(false);
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const fireClickAnalytics = $7b79f828379224e7$var$useLazyClickAnalytics(createAnalyticsEvent, routeDataRef);
    const { openFlyout: openFlyout, closeFlyout: closeFlyout } = (0, $6adZX.useFlyoutActions)();
    const transitionId = (0, $dPJCf.useTransitionId)();
    const getFilteredProductLinks = (0, $gwFzn.useRef)(undefined);
    const [isCustomizeSidebarDialogVisible, setIsCustomizeSidebarDialogVisible] = (0, $gwFzn.useState)(false);
    (0, $gwFzn.useEffect)(()=>{
        if (transitionId && transitionId > 0) //on any transition close open flyout. On initial Load transitionId = 0
        closeFlyout();
    }, [
        closeFlyout,
        transitionId
    ]);
    const moreMenuOnClickCallback = (0, $gwFzn.useCallback)((menuId)=>{
        setIsMoreMenuOpen(!isMoreMenuOpen);
        // TODO: it would be great if we could refactor the following menu-specific logic into the respective menu components
        if (menuId === 'customize') {
            setIsCustomizeSidebarDialogVisible(true);
            fireClickAnalytics('customiseSidebar');
        } else fireClickAnalytics(menuId);
        if (menuId === 'recent' || menuId === 'starred' || menuId === 'spaces') {
            openFlyout(menuId);
            setPeekingId(menuId);
        }
        if (menuId === 'apps') push('/wiki/marketplace/discover');
    }, [
        fireClickAnalytics,
        isMoreMenuOpen,
        openFlyout,
        push
    ]);
    const { data: data, error: error } = (0, $j1Ss3.useQuery)($7b79f828379224e7$var$GlobalNavigationComponentQuery, {
        client: (0, $gKr8t.getAGGClient)(),
        variables: {
            entityAri: (0, $034wI.ConfluenceWorkspaceAri).create({
                siteId: cloudId,
                activationId: activationId
            }).toString(),
            ownerAri: userId ? (0, $bnGHl.IdentityUserAri).create({
                userId: userId
            }).toString() : ''
        },
        skip: !userId
    });
    const platformCustomizations = (0, $gwFzn.useMemo)(()=>{
        if (data?.settings_navigationCustomisation?.sidebar?.nodes) return data.settings_navigationCustomisation.sidebar.nodes.map((node)=>({
                menuId: node.menuId?.replace($7b79f828379224e7$export$311d3c02bd72bcc0, ''),
                visible: Boolean(node.visible)
            }));
        return [];
    }, [
        data
    ]);
    const isPermitted = $7b79f828379224e7$var$hasAccess(accessStatus);
    const { globalMenuItems: globalMenuItems, moreMenuItems: moreMenuItems, appShortcutMenuItems: appShortcutMenuItems, allMenuItems: allMenuItems } = (0, $2usLc.useMenuItems)(isPermitted, platformCustomizations, getFilteredProductLinks.current);
    // The visible app shortcuts:
    // "Company Hub" is the first and only app shortcut at the time of this writing so the naming and abstraction here are as simple as possible.
    let companyHubAppShortcut = null;
    // The item "Customize sidebar" when it's one of the visible global items and app shortcuts:
    let globalCustomizeMenuItem = null;
    const moreMenuItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3z2Im.MoreMenuItem), {
        moreMenuItems: moreMenuItems,
        isOpen: isMoreMenuOpen,
        onClick: moreMenuOnClickCallback,
        toggleMenu: ()=>setIsMoreMenuOpen(!isMoreMenuOpen),
        peekingId: peekingId
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5izcQ.default), {
        name: "nav4-spotlight-0"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9kbAI.MenuList), null, !isOnAnySettingsScreen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5izcQ.default), {
        name: "enhance-orientation-spotlight-tour-target-3"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        "data-vc": "nav4-globalItems"
    }, globalMenuItems.map(({ menuId: menuId })=>{
        const Component = (0, $6bH0k.GlobalItemLoadables)[menuId];
        let node = null;
        if (Component) {
            node = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(Component, {
                key: menuId,
                setIsCustomizeSidebarDialogVisible: setIsCustomizeSidebarDialogVisible
            });
            // All global items stay together and all app shortcuts stay together, they are separate groups.
            // I.e. the app shortcuts should be after a peeking global item (if any).
            // This is the render of the global items section so skip the app shortcuts (of which there is only Company Hub at Team '25 US) here and render them later.
            if ((0, $9wGTI.fg)('company-hub-pseudo-app')) {
                if (menuId === 'companyHub') {
                    companyHubAppShortcut = node;
                    return null;
                } else if (menuId === 'customize') {
                    // The item "Customize sidebar" should be:
                    // - after the app shortcuts if any;
                    // - visually divided from the preceeding global items or app shortcuts.
                    globalCustomizeMenuItem = node;
                    return null;
                }
            }
        }
        return node;
    }), moreMenuItems.map((result)=>{
        const Component = (0, $6bH0k.GlobalItemLoadables)[result.menuId];
        return Component && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(Component, {
            key: result.menuId,
            isHidden: true,
            peekingId: peekingId,
            setPeekingId: setPeekingId,
            setIsCustomizeSidebarDialogVisible: setIsCustomizeSidebarDialogVisible
        });
    }), companyHubAppShortcut && !(0, $9wGTI.fg)('nav4_global_links_confluence') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $hwR8R.VisuallyHiddenDivider), null), companyHubAppShortcut), globalCustomizeMenuItem && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $hwR8R.VisuallyHiddenDivider), null), globalCustomizeMenuItem), isPermitted && !(0, $9wGTI.fg)('nav4_global_links_confluence') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, companyHubAppShortcut && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $hwR8R.VisuallyHiddenDivider), null), moreMenuItem, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $hwR8R.VisuallyHiddenDivider), null)), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorDisplay), {
        error: error
    }), isCustomizeSidebarDialogVisible && ((0, $9wGTI.fg)('confluence_nav4_platform_customization_modal') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($7b79f828379224e7$var$CustomizationModalLoader, {
        onClose: ()=>setIsCustomizeSidebarDialogVisible(false),
        productItemsData: allMenuItems,
        appItemsData: (0, $9wGTI.fg)('nav4_global_links_confluence') ? appShortcutMenuItems : []
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($7b79f828379224e7$var$CustomizeSidebarDialogLoader, {
        globalMenuItems: globalMenuItems,
        moreMenuItems: moreMenuItems,
        onClose: ()=>setIsCustomizeSidebarDialogVisible(false)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $b8XTE.PageSegmentLoadEnd), {
        metric: (0, $1uFsv.GLOBAL_NAVIGATION_METRIC)
    }))), (0, $9wGTI.fg)('nav4_global_links_confluence') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $hwR8R.VisuallyHiddenDivider), null)), productSideNavigation, !isOnAnySettingsScreen && (0, $9wGTI.fg)('nav4_global_links_confluence') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9kbAI.MenuList), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $hwR8R.VisuallyHiddenDivider), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $blzId.GlobalAppShortcuts), {
        orderedMenuConfig: appShortcutMenuItems.map((shortcut)=>({
                menuId: shortcut.menuId,
                visible: shortcut.visible
            })),
        onUpdateGetFilteredProductLinks: (fn)=>{
            getFilteredProductLinks.current = fn;
        }
    }), moreMenuItem));
};
const $7b79f828379224e7$export$94a5e0cf2e657dff = (cache, variables, nodes)=>{
    cache.writeQuery({
        query: $7b79f828379224e7$var$GlobalNavigationComponentQuery,
        variables: variables,
        data: {
            settings_navigationCustomisation: {
                __typename: 'NavigationCustomisation',
                sidebar: {
                    __typename: 'SidebarCustomisation',
                    nodes: nodes
                }
            }
        }
    });
};
const $7b79f828379224e7$var$GlobalNavigationComponentQuery = (0, $d2LG0.default)`query GlobalNavigationComponentQuery($entityAri:ID!$ownerAri:ID!){settings_navigationCustomisation(entityAri:$entityAri ownerAri:$ownerAri){sidebar{nodes{menuId visible}}}}`;

});
parcelRegister("2usLc", function(module, exports) {

$parcel$export(module.exports, "useMenuItems", () => $5cb9965cd3125e0a$export$aad046bd9909db8f);

var $gwFzn = parcelRequire("gwFzn");

var $dsBQ6 = parcelRequire("dsBQ6");

var $1NBp8 = parcelRequire("1NBp8");

var $1ytiN = parcelRequire("1ytiN");

var $7CeAz = parcelRequire("7CeAz");

var $cEgMD = parcelRequire("cEgMD");

var $jyPfN = parcelRequire("jyPfN");

var $eSLr0 = parcelRequire("eSLr0");
var $6ld6a = parcelRequire("6ld6a");

var $9wGTI = parcelRequire("9wGTI");
// Default configuration for all possible top-level items in Confluence Global Nav
const $5cb9965cd3125e0a$var$defaultMenuConfiguration = {
    customHome: {
        defaultVisibility: true,
        authenticationRequired: false,
        isCustomizable: false
    },
    yourWork: {
        defaultVisibility: true,
        authenticationRequired: true,
        isCustomizable: false
    },
    companyHub: {
        defaultVisibility: true,
        authenticationRequired: true,
        isCustomizable: false
    },
    recent: {
        defaultVisibility: true,
        authenticationRequired: true,
        isCustomizable: true
    },
    starred: {
        defaultVisibility: true,
        authenticationRequired: true,
        isCustomizable: true
    },
    spaces: {
        defaultVisibility: true,
        authenticationRequired: false,
        isCustomizable: true
    },
    apps: {
        defaultVisibility: true,
        authenticationRequired: false,
        isCustomizable: true
    },
    goals: {
        //todo: where does this go?
        defaultVisibility: false,
        authenticationRequired: true,
        isCustomizable: true,
        href: '#',
        apsKey: 'GOALS'
    },
    topics: {
        //todo: where does this go?
        defaultVisibility: false,
        authenticationRequired: false,
        isCustomizable: true,
        href: '#'
    },
    teams: {
        defaultVisibility: true,
        authenticationRequired: true,
        isCustomizable: true,
        href: (0, $1NBp8.CONFLUENCE_PEOPLE_DIRECTORY_SEARCH).toUrl()
    },
    drafts: {
        defaultVisibility: false,
        authenticationRequired: true,
        isCustomizable: true,
        href: (0, $1NBp8.HOME).toUrl({
            view: 'drafts'
        })
    },
    tasks: {
        defaultVisibility: false,
        authenticationRequired: true,
        isCustomizable: true,
        href: (0, $1NBp8.HOME).toUrl({
            view: 'tasks'
        })
    },
    templates: {
        defaultVisibility: false,
        authenticationRequired: false,
        isCustomizable: true,
        href: (0, $1NBp8.TEMPLATE_GALLERY).toUrl()
    },
    workflows: {
        defaultVisibility: false,
        authenticationRequired: true,
        isCustomizable: true,
        href: (0, $1NBp8.WORKFLOWS).toUrl()
    },
    companyHubShortcut: {
        defaultVisibility: true,
        authenticationRequired: true,
        isCustomizable: true,
        isAppShortcut: true,
        href: (0, $1NBp8.COMPANY_HUB).toUrl()
    },
    jiraShortcut: {
        defaultVisibility: true,
        authenticationRequired: true,
        isCustomizable: true,
        isAppShortcut: true,
        apsKey: 'JIRA_SOFTWARE'
    },
    loomShortcut: {
        defaultVisibility: true,
        authenticationRequired: true,
        isCustomizable: true,
        isAppShortcut: true,
        apsKey: 'LOOM'
    },
    teamsShortcut: {
        defaultVisibility: true,
        authenticationRequired: true,
        isCustomizable: true,
        isAppShortcut: true,
        apsKey: 'TEAMS'
    },
    customize: {
        defaultVisibility: false,
        authenticationRequired: true,
        isCustomizable: false
    }
};
const $5cb9965cd3125e0a$var$defaultPlatformCustomizationList = Object.entries($5cb9965cd3125e0a$var$defaultMenuConfiguration).filter(([, { isCustomizable: isCustomizable }])=>isCustomizable).map(([menuId, { defaultVisibility: defaultVisibility, isAppShortcut: isAppShortcut }])=>({
        menuId: menuId,
        visible: defaultVisibility,
        isAppShortcut: isAppShortcut || false
    }));
const $5cb9965cd3125e0a$var$mergeCustomizationsWithDefaults = (0, (/*@__PURE__*/$parcel$interopDefault($dsBQ6)))((platformCustomizations)=>{
    const validatedCustomizations = [];
    const customizedMenuIds = new Set();
    platformCustomizations?.forEach((item)=>{
        if ($5cb9965cd3125e0a$var$defaultMenuConfiguration[item.menuId]) {
            validatedCustomizations.push(item);
            customizedMenuIds.add(item.menuId);
        }
    });
    // These items always appear first
    const finalMenuItems = [
        {
            menuId: 'customHome',
            visible: true
        },
        {
            menuId: 'yourWork',
            visible: true
        }
    ];
    const companyHubMenuItem = {
        menuId: 'companyHub',
        visible: true
    };
    if (!(0, $9wGTI.fg)('company-hub-pseudo-app')) // Company Hub was a global item before Team '25 US.
    finalMenuItems.push(companyHubMenuItem);
    // Add any customized menu items
    validatedCustomizations.forEach((item)=>{
        finalMenuItems.push(item);
    });
    // Add any default items that were not customized
    $5cb9965cd3125e0a$var$defaultPlatformCustomizationList.forEach((item)=>{
        if (!customizedMenuIds.has(item.menuId)) finalMenuItems.push(item);
    });
    if ((0, $9wGTI.fg)('company-hub-pseudo-app')) // Company Hub is an app shortcut at Team '25 US.
    finalMenuItems.push(companyHubMenuItem);
    // Customize always appears last
    finalMenuItems.push({
        menuId: 'customize',
        visible: true
    });
    return finalMenuItems;
});
const $5cb9965cd3125e0a$var$createMenuItem = (menuId, config)=>({
        menuId: menuId,
        isCustomizable: config.isCustomizable,
        ...config.href && {
            href: config.href
        },
        ...config.isAppShortcut && {
            isAppShortcut: config.isAppShortcut
        }
    });
const $5cb9965cd3125e0a$var$createMenuItemNext = (menuId, config, visible)=>({
        menuId: menuId,
        visible: visible,
        isNotCustomizable: !config.isCustomizable,
        isNotToggleable: !config.isCustomizable,
        ...config.href && {
            href: config.href
        },
        ...config.isAppShortcut && {
            isAppShortcut: config.isAppShortcut
        }
    });
const $5cb9965cd3125e0a$export$9ef0020da7b7dcc4 = (isPermitted, platformCustomizations, visibilityOverrides, getFilteredProductLinks)=>{
    const globalMenuItems = [];
    const moreMenuItems = [];
    const appShortcutMenuItems = [];
    const allMenuItems = [];
    const orderedItems = $5cb9965cd3125e0a$var$mergeCustomizationsWithDefaults(platformCustomizations);
    const customizeItemId = 'customize';
    orderedItems.forEach((item)=>{
        const menuId = item.menuId;
        const defaultConfig = $5cb9965cd3125e0a$var$defaultMenuConfiguration[menuId];
        if (!(defaultConfig.authenticationRequired && !isPermitted) && visibilityOverrides?.[menuId] !== false && menuId !== customizeItemId && !defaultConfig.isAppShortcut) {
            const menuItem = $5cb9965cd3125e0a$var$createMenuItem(menuId, defaultConfig);
            (item.visible ? globalMenuItems : moreMenuItems).push(menuItem);
            allMenuItems.push($5cb9965cd3125e0a$var$createMenuItemNext(menuId, defaultConfig, item.visible));
        }
        // APP SHORTCUTS
        if (visibilityOverrides?.[menuId] && defaultConfig.isAppShortcut) {
            appShortcutMenuItems.push($5cb9965cd3125e0a$var$createMenuItemNext(item.menuId, defaultConfig, item.visible));
            if (!item.visible) {
                const pushConfig = {
                    ...defaultConfig
                };
                if (getFilteredProductLinks && defaultConfig.apsKey) pushConfig.href = getFilteredProductLinks(defaultConfig.apsKey)?.promotedLink?.url;
                moreMenuItems.push($5cb9965cd3125e0a$var$createMenuItem(item.menuId, pushConfig));
            }
        }
    });
    // customize sidebar item should be the last item of the more items menu
    // unless there are no items, then it should be in the global menu items
    if (isPermitted && visibilityOverrides?.[customizeItemId] !== false) {
        const customizeItem = $5cb9965cd3125e0a$var$createMenuItem(customizeItemId, $5cb9965cd3125e0a$var$defaultMenuConfiguration[customizeItemId]);
        (moreMenuItems.length === 0 ? globalMenuItems : moreMenuItems).push(customizeItem);
    }
    return {
        globalMenuItems: globalMenuItems,
        moreMenuItems: moreMenuItems,
        allMenuItems: allMenuItems,
        appShortcutMenuItems: appShortcutMenuItems
    };
};
const $5cb9965cd3125e0a$export$aad046bd9909db8f = (isPermitted, platformCustomizations, getFilteredProductLinks)=>{
    const { loading: webItemsLoading, webItems: webItems } = (0, $6ld6a.useWebItemLocation)({
        location: (0, $eSLr0.SYSTEM_HEADER_LEFT),
        allowedWebItems: [
            $5cb9965cd3125e0a$export$8fa81f0104234d32,
            $5cb9965cd3125e0a$export$78f3e9dc1aa1d31d
        ]
    });
    const { isCompanyHubEntryPointEnabled: isCompanyHubEntryPointEnabled } = (0, $7CeAz.useIsCompanyHubEnabled)();
    const { canViewUserProfile: hasViewUserProfilePermission } = (0, $jyPfN.useViewUserProfile)();
    const { homepageUri: homepageUri, frontCoverState: frontCoverState, loading: loading } = (0, $gwFzn.useContext)((0, $1ytiN.SPAViewContext));
    const isSpacesVisible = !webItemsLoading && !!webItems.find((item)=>item.completeKey === $5cb9965cd3125e0a$export$8fa81f0104234d32);
    const isPeopleVisible = !webItemsLoading && (hasViewUserProfilePermission || !!webItems.find((item)=>item.completeKey === $5cb9965cd3125e0a$export$78f3e9dc1aa1d31d));
    const isCompanyHubVisible = !loading && isCompanyHubEntryPointEnabled && !!frontCoverState;
    const isCompanyHubSetAsCustomHome = isCompanyHubVisible && homepageUri.includes((0, $cEgMD.getCompanyHubSpaceKey)());
    const isCustomHomeVisible = !isCompanyHubSetAsCustomHome && ![
        '/spa.action',
        '',
        'homepageUri'
    ].includes(homepageUri);
    return (0, $gwFzn.useMemo)(()=>{
        // remove elements from the returned data structures based on application state and override defaults and customization store
        // eslint-disable-next-line confluence-feature-gating/inline-usage
        const visibilityOverrides = {
            customHome: isCustomHomeVisible,
            companyHub: isCompanyHubVisible && !(0, $9wGTI.fg)('nav4_global_links_confluence'),
            spaces: isSpacesVisible,
            teams: isPeopleVisible && !(0, $9wGTI.fg)('nav4_gas_include_teams'),
            topics: false,
            goals: false,
            templates: true,
            drafts: true,
            tasks: true,
            workflows: (0, $9wGTI.fg)('document_workflows'),
            customize: true,
            companyHubShortcut: isCompanyHubVisible && (0, $9wGTI.fg)('nav4_global_links_confluence'),
            jiraShortcut: (0, $9wGTI.fg)('nav4_global_links_confluence'),
            loomShortcut: (0, $9wGTI.fg)('nav4_global_links_confluence'),
            teamsShortcut: isPeopleVisible && (0, $9wGTI.fg)('nav4_gas_include_teams')
        };
        return $5cb9965cd3125e0a$export$9ef0020da7b7dcc4(isPermitted, platformCustomizations, visibilityOverrides, getFilteredProductLinks);
    }, [
        isCustomHomeVisible,
        isCompanyHubVisible,
        isSpacesVisible,
        isPeopleVisible,
        isPermitted,
        platformCustomizations,
        getFilteredProductLinks
    ]);
};
const $5cb9965cd3125e0a$export$8fa81f0104234d32 = 'com.atlassian.confluence.plugins.confluence-space-ia:header-spaces-link';
const $5cb9965cd3125e0a$export$78f3e9dc1aa1d31d = 'com.atlassian.confluence.plugins.confluence-space-ia:header-people-link';

});

parcelRegister("6bH0k", function(module, exports) {

$parcel$export(module.exports, "GlobalItemLoadables", () => $aed9a11c7417b1cd$export$c15a2a0e7d6d042);

var $jmjWc = parcelRequire("jmjWc");

const $aed9a11c7417b1cd$var$CustomHomeLoader = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "Hy3Mb",
    name: "CustomHomeLoader",
    loader: async ()=>(await (parcelRequire("41NLW"))).CustomHomeItem
});

const $aed9a11c7417b1cd$var$ForYouLoader = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "6r78p",
    name: "ForYouLoader",
    loader: async ()=>(await (parcelRequire("9Hwyu"))).ForYouItem
});

const $aed9a11c7417b1cd$var$RecentLoader = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "MRzCI",
    name: "RecentLoader",
    loader: async ()=>(await (parcelRequire("8qMnh"))).RecentItem
});

const $aed9a11c7417b1cd$var$StarredLoader = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "lfrfm",
    name: "StarredLoader",
    loader: async ()=>(await (parcelRequire("lUbvg"))).StarredItem
});

const $aed9a11c7417b1cd$var$CompanyHubLoader = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "GOhUP",
    name: "CompanyHubLoader",
    loader: async ()=>(await (parcelRequire("17Fb5"))).CompanyHubItem
});

const $aed9a11c7417b1cd$var$SpacesLoader = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "wS2gu",
    name: "SpacesLoader",
    loader: async ()=>(await (parcelRequire("lLGJ2"))).SpacesItem
});

const $aed9a11c7417b1cd$var$AppsLoader = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "RHriH",
    name: "AppsLoader",
    loader: async ()=>(await (parcelRequire("dfjnw"))).AppsItem
});

const $aed9a11c7417b1cd$var$GoalsLoader = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "9lsr9",
    name: "GoalsLoader",
    loader: async ()=>(await (parcelRequire("c4UIf"))).GoalsItem
});

const $aed9a11c7417b1cd$var$TopicsLoader = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "KmtrM",
    name: "TopicsLoader",
    loader: async ()=>(await (parcelRequire("7kO5X"))).TopicsItem
});

const $aed9a11c7417b1cd$var$TeamsLoader = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "RpRsi",
    name: "TeamsLoader",
    loader: async ()=>(await (parcelRequire("8wXqN"))).TeamsItem
});

const $aed9a11c7417b1cd$var$DraftsLoader = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "mLx5j",
    name: "DraftsLoader",
    loader: async ()=>(await (parcelRequire("5pGrH"))).DraftsItem
});

const $aed9a11c7417b1cd$var$TasksLoader = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "MGRE_",
    name: "TasksLoader",
    loader: async ()=>(await (parcelRequire("P4hxA"))).TasksItem
});

const $aed9a11c7417b1cd$var$TemplatesLoader = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "E29W8",
    name: "TemplatesLoader",
    loader: async ()=>(await (parcelRequire("4jdtO"))).TemplatesItem
});

const $aed9a11c7417b1cd$var$WorkflowsLoader = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "FGTrJ",
    name: "WorkflowsLoader",
    loader: async ()=>(await (parcelRequire("baXAT"))).WorkflowsItem
});

const $aed9a11c7417b1cd$var$CustomizeSidebarLoader = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "Mtlik",
    name: "CustomizeSidebarLoader",
    loader: async ()=>(await (parcelRequire("c6xWS"))).CustomizeSidebarItem
});
const $aed9a11c7417b1cd$export$c15a2a0e7d6d042 = {
    customHome: $aed9a11c7417b1cd$var$CustomHomeLoader,
    yourWork: $aed9a11c7417b1cd$var$ForYouLoader,
    companyHub: $aed9a11c7417b1cd$var$CompanyHubLoader,
    recent: $aed9a11c7417b1cd$var$RecentLoader,
    starred: $aed9a11c7417b1cd$var$StarredLoader,
    spaces: $aed9a11c7417b1cd$var$SpacesLoader,
    apps: $aed9a11c7417b1cd$var$AppsLoader,
    goals: $aed9a11c7417b1cd$var$GoalsLoader,
    topics: $aed9a11c7417b1cd$var$TopicsLoader,
    teams: $aed9a11c7417b1cd$var$TeamsLoader,
    drafts: $aed9a11c7417b1cd$var$DraftsLoader,
    tasks: $aed9a11c7417b1cd$var$TasksLoader,
    templates: $aed9a11c7417b1cd$var$TemplatesLoader,
    workflows: $aed9a11c7417b1cd$var$WorkflowsLoader,
    customize: $aed9a11c7417b1cd$var$CustomizeSidebarLoader
};

});
parcelRegister("41NLW", function(module, exports) {

let $2eeddd21bbd51a11$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $2eeddd21bbd51a11$var$load("5628Q").then(()=>parcelRequire('1sXyY'));

});

parcelRegister("9Hwyu", function(module, exports) {

let $7101620089852554$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $7101620089852554$var$load("1hbKG"),
    $7101620089852554$var$load("i2OFv"),
    $7101620089852554$var$load("8miHS"),
    $7101620089852554$var$load("54EcW"),
    $7101620089852554$var$load("27phM"),
    $7101620089852554$var$load("c6MKV"),
    $7101620089852554$var$load("fwbht"),
    $7101620089852554$var$load("z7pZc")
]).then(()=>parcelRequire('jUVz4'));

});

parcelRegister("8qMnh", function(module, exports) {

let $6236469a584f117f$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $6236469a584f117f$var$load("1hbKG"),
    $6236469a584f117f$var$load("i2OFv"),
    $6236469a584f117f$var$load("lHFx3"),
    $6236469a584f117f$var$load("54EcW"),
    $6236469a584f117f$var$load("fwbht"),
    $6236469a584f117f$var$load("6qah4"),
    $6236469a584f117f$var$load("6nLV7"),
    $6236469a584f117f$var$load("c6MKV"),
    $6236469a584f117f$var$load("8miHS"),
    $6236469a584f117f$var$load("25CqL")
]).then(()=>parcelRequire('6mTAL'));

});

parcelRegister("lUbvg", function(module, exports) {

let $ff27c03c445c67c8$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $ff27c03c445c67c8$var$load("1hbKG"),
    $ff27c03c445c67c8$var$load("i2OFv"),
    $ff27c03c445c67c8$var$load("l7m0F"),
    $ff27c03c445c67c8$var$load("hNn7N"),
    $ff27c03c445c67c8$var$load("aCOx0"),
    $ff27c03c445c67c8$var$load("lHFx3"),
    $ff27c03c445c67c8$var$load("54EcW"),
    $ff27c03c445c67c8$var$load("bO41X"),
    $ff27c03c445c67c8$var$load("aZinD"),
    $ff27c03c445c67c8$var$load("fwbht"),
    $ff27c03c445c67c8$var$load("lUlCu"),
    $ff27c03c445c67c8$var$load("joJy8"),
    $ff27c03c445c67c8$var$load("aHE9G"),
    $ff27c03c445c67c8$var$load("ffEVr"),
    $ff27c03c445c67c8$var$load("c6MKV"),
    $ff27c03c445c67c8$var$load("8miHS"),
    $ff27c03c445c67c8$var$load("4v96t")
]).then(()=>parcelRequire('4id39'));

});

parcelRegister("17Fb5", function(module, exports) {

let $0d1662f032f7b728$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $0d1662f032f7b728$var$load("1hbKG"),
    $0d1662f032f7b728$var$load("i2OFv"),
    $0d1662f032f7b728$var$load("gQpJ0")
]).then(()=>parcelRequire('8jEPG'));

});

parcelRegister("lLGJ2", function(module, exports) {

let $fd8f21219dbb40c3$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $fd8f21219dbb40c3$var$load("1hbKG"),
    $fd8f21219dbb40c3$var$load("i2OFv"),
    $fd8f21219dbb40c3$var$load("l7m0F"),
    $fd8f21219dbb40c3$var$load("hNn7N"),
    $fd8f21219dbb40c3$var$load("lfEn7"),
    $fd8f21219dbb40c3$var$load("lHFx3"),
    $fd8f21219dbb40c3$var$load("iOXIX"),
    $fd8f21219dbb40c3$var$load("76oYl"),
    $fd8f21219dbb40c3$var$load("aZinD"),
    $fd8f21219dbb40c3$var$load("c6MKV"),
    $fd8f21219dbb40c3$var$load("fwbht"),
    $fd8f21219dbb40c3$var$load("1epse"),
    $fd8f21219dbb40c3$var$load("lUlCu"),
    $fd8f21219dbb40c3$var$load("joJy8"),
    $fd8f21219dbb40c3$var$load("aHE9G"),
    $fd8f21219dbb40c3$var$load("8miHS"),
    $fd8f21219dbb40c3$var$load("9cZwe")
]).then(()=>parcelRequire('4bY0V'));

});

parcelRegister("dfjnw", function(module, exports) {

let $9a4bb5360b679c02$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $9a4bb5360b679c02$var$load("l7m0F"),
    $9a4bb5360b679c02$var$load("hNn7N"),
    $9a4bb5360b679c02$var$load("8miHS"),
    $9a4bb5360b679c02$var$load("lHFx3"),
    $9a4bb5360b679c02$var$load("6S3Gy"),
    $9a4bb5360b679c02$var$load("6jw5Q"),
    $9a4bb5360b679c02$var$load("7sZmN"),
    $9a4bb5360b679c02$var$load("ffEVr"),
    $9a4bb5360b679c02$var$load("l1RZs")
]).then(()=>parcelRequire('iCBn9'));

});

parcelRegister("c4UIf", function(module, exports) {

let $8cb1d9b6a1f9956e$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $8cb1d9b6a1f9956e$var$load("lHFx3"),
    $8cb1d9b6a1f9956e$var$load("fRXAy")
]).then(()=>parcelRequire('1W3KQ'));

});

parcelRegister("7kO5X", function(module, exports) {

let $55714282092f39b2$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $55714282092f39b2$var$load("lHFx3"),
    $55714282092f39b2$var$load("dhvtB")
]).then(()=>parcelRequire('9RToo'));

});

parcelRegister("8wXqN", function(module, exports) {

let $635f69b2b6e3bb77$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $635f69b2b6e3bb77$var$load("lHFx3"),
    $635f69b2b6e3bb77$var$load("jPZJ9")
]).then(()=>parcelRequire('exxzK'));

});

parcelRegister("5pGrH", function(module, exports) {

let $3f103660a3b42b20$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $3f103660a3b42b20$var$load("lHFx3"),
    $3f103660a3b42b20$var$load("6qteY")
]).then(()=>parcelRequire('aQvhQ'));

});

parcelRegister("P4hxA", function(module, exports) {

let $099815d56e31d934$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $099815d56e31d934$var$load("lHFx3"),
    $099815d56e31d934$var$load("5vMiA")
]).then(()=>parcelRequire('kgqYY'));

});

parcelRegister("4jdtO", function(module, exports) {

let $323364957db31e66$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $323364957db31e66$var$load("lHFx3"),
    $323364957db31e66$var$load("3SSQy")
]).then(()=>parcelRequire('1mzMT'));

});

parcelRegister("baXAT", function(module, exports) {

let $822edb071c1869a8$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $822edb071c1869a8$var$load("lHFx3"),
    $822edb071c1869a8$var$load("5g5mr")
]).then(()=>parcelRequire('izp1J'));

});

parcelRegister("c6xWS", function(module, exports) {

let $8d00611430645561$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $8d00611430645561$var$load("lHFx3"),
    $8d00611430645561$var$load("7l2yo")
]).then(()=>parcelRequire('g8JDX'));

});


parcelRegister("blzId", function(module, exports) {

$parcel$export(module.exports, "GlobalAppShortcuts", () => $7bd10afdb5dbc6b1$export$69209b4d7b9e00bc);

var $gwFzn = parcelRequire("gwFzn");

var $ay6Zz = parcelRequire("ay6Zz");

var $gasvu = parcelRequire("gasvu");
var $k3207 = parcelRequire("k3207");

var $7jA14 = parcelRequire("7jA14");

var $12t1c = parcelRequire("12t1c");

var $aZVNi = parcelRequire("aZVNi");

var $GEjfy = parcelRequire("GEjfy");

var $9wGTI = parcelRequire("9wGTI");

var $1NBp8 = parcelRequire("1NBp8");

var $bQm3c = parcelRequire("bQm3c");

var $6bH0k = parcelRequire("6bH0k");

var $5OTt8 = parcelRequire("5OTt8");

var $hwR8R = parcelRequire("hwR8R");
function $7bd10afdb5dbc6b1$var$companyHubComponent() {
    return {
        ...(0, $7jA14.default)(()=>(0, $1NBp8.COMPANY_HUB).toUrl()),
        component: (0, $6bH0k.GlobalItemLoadables).companyHub
    };
}
const $7bd10afdb5dbc6b1$export$69209b4d7b9e00bc = ({ orderedMenuConfig: orderedMenuConfig = [], onUpdateGetFilteredProductLinks: onUpdateGetFilteredProductLinks })=>{
    const { cloudId: cloudId, orgId: orgId } = (0, $bQm3c.useSessionData)();
    const { href: href } = (0, $ay6Zz.navigateToTeamsApp)({
        type: 'LANDING',
        cloudId: cloudId,
        orgId: orgId,
        userHasNav4Enabled: true
    });
    const updateGetFilteredProductLinks = (0, $gwFzn.useCallback)((getFilteredProductLinks)=>{
        if (onUpdateGetFilteredProductLinks) onUpdateGetFilteredProductLinks(getFilteredProductLinks);
    }, [
        onUpdateGetFilteredProductLinks
    ]);
    // Map shortcut configs to menu identifiers
    const shortcutItemsConfig = (0, $gwFzn.useMemo)(()=>{
        return {
            companyHubShortcut: $7bd10afdb5dbc6b1$var$companyHubComponent(),
            jiraShortcut: (0, $12t1c.default)(()=>''),
            loomShortcut: (0, $aZVNi.default)(()=>''),
            ...(0, $9wGTI.fg)('nav4_gas_include_teams') ? {
                teamsShortcut: (0, $GEjfy.default)(()=>href)
            } : {}
        };
    }, [
        href
    ]);
    // Sort shortcut items based on the ordered menu config
    const orderedShortcuts = (0, $5OTt8.useOrderedAppShortcuts)(shortcutItemsConfig, orderedMenuConfig);
    const productLinksFilter = cloudId ? (0, $k3207.productLinksWorkspaceCloudIdFilter)(cloudId) : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gasvu.default), {
        testId: "global-app-shortcuts",
        cloudId: cloudId,
        orgId: orgId,
        shortcutItems: orderedShortcuts,
        promoteSite: true,
        product: "confluence",
        productLinksFilter: productLinksFilter,
        onUpdateGetFilteredProductLinks: updateGetFilteredProductLinks
    }), orderedShortcuts.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $hwR8R.VisuallyHiddenDivider), null));
};

});
parcelRegister("gasvu", function(module, exports) {

$parcel$export(module.exports, "default", () => $26f372a5788858af$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $7TH2w = parcelRequire("7TH2w");

var $ffCOo = parcelRequire("ffCOo");

var $inPa6 = parcelRequire("inPa6");

var $9kbAI = parcelRequire("9kbAI");

var $eyWa4 = parcelRequire("eyWa4");

var $4jETc = parcelRequire("4jETc");
var $caUKj = parcelRequire("caUKj");
var $cmWXZ = parcelRequire("cmWXZ");

var $culkJ = parcelRequire("culkJ");

var $fqJ57 = parcelRequire("fqJ57");

var $kslv8 = parcelRequire("kslv8");

var $g2RNl = parcelRequire("g2RNl");

var $5hYae = parcelRequire("5hYae");
function $26f372a5788858af$var$Menu({ testId: testId, shortcutItems: shortcutItems = [], forceStatic: forceStatic, cloudId: cloudId, orgId: orgId, useSkeleton: useSkeleton, promoteSite: promoteSite, productLinksFilter: productLinksFilter, product: product, onUpdateGetFilteredProductLinks: onUpdateGetFilteredProductLinks }) {
    // Update Ref
    const onUpdateGetFilteredProductLinksRef = (0, $gwFzn.useRef)(onUpdateGetFilteredProductLinks);
    onUpdateGetFilteredProductLinksRef.current = onUpdateGetFilteredProductLinks;
    // Filter Ref
    const productLinksFilterRef = (0, $gwFzn.useRef)(productLinksFilter);
    productLinksFilterRef.current = productLinksFilter;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { buildURLAndFetchData: buildURLAndFetchData, status: status, productLinks: productLinks } = (0, $cmWXZ.useBFFDataProvider)({
        request: {},
        cloudId: cloudId,
        orgId: orgId,
        forceStatic: forceStatic
    });
    const getFilteredProductLinks = (0, $gwFzn.useCallback)((apsKey)=>{
        let filteredProductLinks = productLinks[apsKey] ?? [];
        if (productLinksFilterRef.current) filteredProductLinks = filteredProductLinks.filter(productLinksFilterRef.current);
        return {
            promotedLink: filteredProductLinks.find((item, _i, arr)=>arr.length === 1 || promoteSite && item.isCurrentSite),
            links: filteredProductLinks.filter((item, _i, arr)=>arr.length === 1 || !(promoteSite && item.isCurrentSite))
        };
    }, [
        productLinks,
        promoteSite
    ]);
    const mappedShortcutItems = (0, $gwFzn.useMemo)(()=>{
        return shortcutItems.map((item, index)=>{
            const key = item.apsKey || `shortcut-${index}`;
            // Render nested items if the dynamic data is available and we are not forcing static rendering
            if (!forceStatic && status?.toLowerCase() === (0, $4jETc.RequestStatus).COMPLETE && item?.apsKey && productLinks?.[item.apsKey]) {
                const { links: filteredProductLinks, promotedLink: promotedLink } = getFilteredProductLinks(item.apsKey);
                const siteName = filteredProductLinks?.[0]?.displayName;
                // Determine whether shortcut is a single site and is current site and return link instead of flyout
                if (filteredProductLinks.length === 1 && !item.url) item.url = filteredProductLinks[0].url;
                return {
                    ...item,
                    siteName: siteName,
                    key: key,
                    promoted: promotedLink ? {
                        icon: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $kslv8.ImageFromUrl), {
                            src: promotedLink.avatar,
                            alt: "",
                            fallback: item.icon
                        }),
                        label: promotedLink.displayName,
                        url: promotedLink.url
                    } : undefined,
                    items: filteredProductLinks.map((link)=>({
                            icon: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $kslv8.ImageFromUrl), {
                                src: link.avatar,
                                alt: "",
                                fallback: item.icon
                            }),
                            label: link.displayName,
                            displayName: link.displayName,
                            url: link.url
                        }))
                };
            }
            return {
                ...item,
                key: key
            };
        });
    }, [
        shortcutItems,
        productLinks,
        forceStatic,
        status,
        getFilteredProductLinks
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (onUpdateGetFilteredProductLinksRef.current) onUpdateGetFilteredProductLinksRef.current(getFilteredProductLinks);
    }, [
        getFilteredProductLinks
    ]);
    const apsKeys = (0, $gwFzn.useMemo)(()=>{
        return shortcutItems.map((item)=>item.apsKey || '').filter((item)=>!!item);
    }, [
        shortcutItems
    ]);
    const mountedRef = (0, $gwFzn.useRef)(false);
    (0, $gwFzn.useEffect)(()=>{
        if (forceStatic || status?.toLowerCase() !== (0, $4jETc.RequestStatus).COMPLETE || !Object.keys(productLinks).length || mountedRef.current === true) return;
        mountedRef.current = true;
        const missingShortcuts = shortcutItems.filter((item)=>{
            return !item.url && !item.fallbackUrl?.() && item.apsKey && !productLinks[item.apsKey];
        });
        const intended = shortcutItems.length;
        const rendered = intended - missingShortcuts.length;
        createAnalyticsEvent({
            eventType: (0, $7TH2w.UI_EVENT_TYPE),
            action: 'cls',
            actionSubject: 'menu',
            actionSubjectId: 'globalNavigation',
            attributes: {
                name: product,
                intended: intended,
                rendered: rendered,
                missingAPSKeys: missingShortcuts.map((item)=>item.apsKey).filter(Boolean)
            }
        }).fire((0, $culkJ.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        shortcutItems,
        productLinks,
        product,
        forceStatic,
        status
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (!forceStatic) buildURLAndFetchData(apsKeys);
    }, [
        apsKeys,
        buildURLAndFetchData,
        forceStatic
    ]);
    const createLinkItem = (0, $gwFzn.useCallback)((shortcut)=>{
        if (status?.toLowerCase() === (0, $4jETc.RequestStatus).COMPLETE) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5hYae.ShortcutMenuItem), {
            shortcut: shortcut,
            status: status,
            expandItems: shortcut.items && shortcut.items.length > 1 ? shortcut.items : undefined,
            promotedItem: shortcut.promoted,
            siteName: shortcut.siteName
        }, shortcut.key);
        // Show skeleton while BFF is loading
        if (useSkeleton && (status === (0, $4jETc.RequestStatus).LOADING || status === (0, $4jETc.RequestStatus).INIT)) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $g2RNl.MenuSkeletonItem), {}, shortcut.key);
        // We only want to allow static menu expand item if we are forcing static,
        // otherwise it should be showing the singular item as a disabled link until the
        // data is loaded.
        if (forceStatic && shortcut.items) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5hYae.ShortcutMenuItem), {
            shortcut: shortcut,
            expandItems: shortcut.items,
            forceStatic: forceStatic
        }, shortcut.key);
        return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5hYae.ShortcutMenuItem), {
            shortcut: shortcut,
            status: status,
            forceStatic: forceStatic
        }, shortcut.key);
    }, [
        forceStatic,
        status,
        useSkeleton
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $eyWa4.default), {
        testId: testId,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9kbAI.MenuList), {
            children: mappedShortcutItems?.map(createLinkItem)
        })
    });
}
function $26f372a5788858af$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $caUKj.BFFProvider), {
        consumer: (0, $4jETc.BFFConsumerEnum).GLOBAL_SHORTCUTS,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fqJ57.GlobalShortcutsWithIntlProvider), {
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $ffCOo.NavigationAnalyticsContext), {
                data: {
                    product: props?.product
                },
                children: /*#__PURE__*/ (0, $7UHDa.jsx)($26f372a5788858af$var$Menu, {
                    ...props
                })
            })
        })
    });
}

});
parcelRegister("4jETc", function(module, exports) {

$parcel$export(module.exports, "BFFConsumerEnum", () => $3fcb4d970a94e7e9$export$9a146e025690327e);
$parcel$export(module.exports, "ASSETS_APP_KEY", () => $3fcb4d970a94e7e9$export$45e63649edff1e2a);
$parcel$export(module.exports, "MAX_ATTEMPTS_DEFAULT", () => $3fcb4d970a94e7e9$export$45c80c6b98d65f36);
$parcel$export(module.exports, "RETRY_INTERVAL_DEFAULT", () => $3fcb4d970a94e7e9$export$7b4183e5f0de390a);
$parcel$export(module.exports, "DAYS_AUTO_PROVISIONED_ITEM_CONSIDERED_NEW", () => $3fcb4d970a94e7e9$export$891dc7068a3d5e65);
$parcel$export(module.exports, "DAYS_END_USER_ACTIVE_PRODUCT_CONSIDERED_NEW", () => $3fcb4d970a94e7e9$export$6e594fe130dbe3b);
$parcel$export(module.exports, "RequestStatus", () => $3fcb4d970a94e7e9$export$600e7c1f9e0414e1);
$parcel$export(module.exports, "BFF_REQUEST_STATUS_KEY", () => $3fcb4d970a94e7e9$export$c889532d47d74e9c);
$parcel$export(module.exports, "FLIGHTDECK_REQUEST_STATUS_KEY", () => $3fcb4d970a94e7e9$export$123b1b8742c0ac6a);
var $3fcb4d970a94e7e9$export$9a146e025690327e = /*#__PURE__*/ function(BFFConsumerEnum) {
    BFFConsumerEnum["ATLASSIAN_SWITCHER"] = "ATLASSIAN_SWITCHER";
    BFFConsumerEnum["GLOBAL_SHORTCUTS"] = "GLOBAL_SHORTCUTS";
    BFFConsumerEnum["GLOBAL_SIDE_NAVIGATION"] = "GLOBAL_SIDE_NAVIGATION";
    BFFConsumerEnum["UNIVERSAL_CREATE"] = "UNIVERSAL_CREATE";
    return BFFConsumerEnum;
}({});
const $3fcb4d970a94e7e9$export$45e63649edff1e2a = 'ASSETS';
const $3fcb4d970a94e7e9$export$45c80c6b98d65f36 = 3;
const $3fcb4d970a94e7e9$export$7b4183e5f0de390a = 1000;
const $3fcb4d970a94e7e9$export$891dc7068a3d5e65 = 14;
const $3fcb4d970a94e7e9$export$6e594fe130dbe3b = 14;
var $3fcb4d970a94e7e9$export$600e7c1f9e0414e1 = /*#__PURE__*/ function(RequestStatus) {
    RequestStatus["INIT"] = "initializing";
    RequestStatus["LOADING"] = "loading";
    RequestStatus["COMPLETE"] = "complete";
    RequestStatus["ERROR"] = "error";
    return RequestStatus;
}({});
const $3fcb4d970a94e7e9$export$c889532d47d74e9c = 'bff';
const $3fcb4d970a94e7e9$export$123b1b8742c0ac6a = 'flightdeck';
const $3fcb4d970a94e7e9$export$95d80cce92acae9 = 'uc-suggestions';

});

parcelRegister("caUKj", function(module, exports) {

$parcel$export(module.exports, "BFFContext", () => $f9a84eccaed6c052$export$873dcaf380a86d6b);
$parcel$export(module.exports, "BFFProvider", () => $f9a84eccaed6c052$export$71a938590b6955cc);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $4jETc = parcelRequire("4jETc");
const $f9a84eccaed6c052$export$b2445cd6f2d7fd5 = {
    cache: {},
    cacheKey: '',
    status: null,
    consumer: null
};
const $f9a84eccaed6c052$export$873dcaf380a86d6b = /*#__PURE__*/ (0, $gwFzn.createContext)({
    value: $f9a84eccaed6c052$export$b2445cd6f2d7fd5,
    currentLoadingRequests: [],
    setValue: ()=>{},
    updateCurrentLoadingRequests: (name, status)=>{}
});
function $f9a84eccaed6c052$export$71a938590b6955cc({ consumer: consumer, children: children }) {
    const [value, setValue] = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useState({
        cache: {},
        cacheKey: consumer,
        consumer: consumer,
        status: (0, $4jETc.RequestStatus).INIT
    });
    const [currentLoadingRequests, setCurrentLoadingRequests] = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useState([]);
    const updateCurrentLoadingRequests = (0, $gwFzn.useCallback)((name, status)=>{
        switch(status){
            case (0, $4jETc.RequestStatus).LOADING:
                setCurrentLoadingRequests((prev)=>[
                        ...prev,
                        name
                    ]);
                break;
            case (0, $4jETc.RequestStatus).COMPLETE:
                setCurrentLoadingRequests((prev)=>prev.filter((request)=>request !== name));
                break;
            case (0, $4jETc.RequestStatus).ERROR:
                setCurrentLoadingRequests([]);
                break;
        }
    }, [
        setCurrentLoadingRequests
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)($f9a84eccaed6c052$export$873dcaf380a86d6b.Provider, {
        value: {
            value: value,
            setValue: setValue,
            currentLoadingRequests: currentLoadingRequests,
            updateCurrentLoadingRequests: updateCurrentLoadingRequests
        },
        children: children
    });
}

});

parcelRegister("cmWXZ", function(module, exports) {

$parcel$export(module.exports, "useBFFDataProvider", () => $f19027b153d497cf$export$a00b492c9c3c66db);

var $gwFzn = parcelRequire("gwFzn");

var $4jETc = parcelRequire("4jETc");

var $6lFYf = parcelRequire("6lFYf");

var $6Tx9o = parcelRequire("6Tx9o");

var $7TOrm = parcelRequire("7TOrm");

var $ik19A = parcelRequire("ik19A");

var $cdX3N = parcelRequire("cdX3N");
async function $f19027b153d497cf$var$wait(ms) {
    return new Promise((resolve)=>{
        setTimeout(resolve, ms);
    });
}
function $f19027b153d497cf$export$a00b492c9c3c66db({ request: request, cloudId: cloudId, orgId: orgId, forceStatic: forceStatic }) {
    const { items: cachedItems, addItemsToCache: addItemsToCache, clearCache: clearCache, cacheKey: cacheKey, updateCacheKey: updateCacheKey } = (0, $6Tx9o.useCache)();
    const { setStatus: setStatus, status: status } = (0, $ik19A.useStatus)();
    const { productLinks: productLinks } = (0, $7TOrm.useProductLinks)({
        cloudId: cloudId,
        orgId: orgId,
        forceStatic: forceStatic
    });
    const { buildURL: buildURL } = (0, $cdX3N.useURLBuilder)({
        cloudId: cloudId
    });
    const currentRequest = (0, $gwFzn.useRef)(null);
    const fetchData = (0, $gwFzn.useCallback)(async (url, data, attemptCount = 1, successCheck)=>{
        if (url === '') throw new Error('URL is empty');
        setStatus((0, $4jETc.RequestStatus).LOADING, (0, $4jETc.BFF_REQUEST_STATUS_KEY));
        try {
            const response = await (0, $6lFYf.fetchJSON)(url, {});
            switch(response.status){
                case (0, $4jETc.RequestStatus).ERROR:
                    throw response.error;
                case (0, $4jETc.RequestStatus).COMPLETE:
                    if (!successCheck || successCheck(response.data)) {
                        setStatus((0, $4jETc.RequestStatus).COMPLETE, (0, $4jETc.BFF_REQUEST_STATUS_KEY));
                        currentRequest.current = null;
                        return response.data;
                    } else throw new Error('BFF success check failed');
            }
        } catch (e) {
            const maxAttempts = request?.maxAttempts ?? (0, $4jETc.MAX_ATTEMPTS_DEFAULT);
            if (request?.shouldRetryOnException && attemptCount < maxAttempts) {
                // Introduce longer wait times for each retry attempt
                await $f19027b153d497cf$var$wait((request?.attemptInterval ?? (0, $4jETc.RETRY_INTERVAL_DEFAULT)) * attemptCount);
                return await fetchData(url, data, attemptCount + 1, successCheck);
            } else {
                currentRequest.current = null;
                setStatus((0, $4jETc.RequestStatus).ERROR);
                throw new Error('Max attempts reached');
            }
        }
    }, [
        request?.attemptInterval,
        request?.maxAttempts,
        request?.shouldRetryOnException,
        setStatus
    ]);
    /**
	 * Helper function to build a URL and fetch data.
	 */ const buildURLAndFetchData = (0, $gwFzn.useCallback)(async (requestedAPSKeys)=>{
        // Wait for the current request to end before firing another
        if (currentRequest.current) return currentRequest.current;
        const builtUrl = buildURL({
            requestedAPSKeys: requestedAPSKeys
        });
        if (builtUrl !== '') {
            currentRequest.current = fetchData(builtUrl, undefined, undefined, (result)=>{
                return result.sites && result.sites.length > 0;
            });
            const fetchedData = await currentRequest.current;
            if (fetchedData.sites && fetchedData.sites.length) addItemsToCache(fetchedData.sites);
        }
    }, [
        addItemsToCache,
        buildURL,
        fetchData
    ]);
    return {
        status: status,
        cachedItems: cachedItems,
        cacheKey: cacheKey,
        updateCacheKey: updateCacheKey,
        addItemsToCache: addItemsToCache,
        clearCache: clearCache,
        buildURL: buildURL,
        fetchData: fetchData,
        buildURLAndFetchData: buildURLAndFetchData,
        productLinks: productLinks
    };
}

});
parcelRegister("6lFYf", function(module, exports) {

$parcel$export(module.exports, "isLocalHost", () => $1d9cedda3a5081bf$export$f931afb2c5ecf7c7);
$parcel$export(module.exports, "fetchJSON", () => $1d9cedda3a5081bf$export$81bec6e38e8b706b);

var $4jETc = parcelRequire("4jETc");

var $dr83e = parcelRequire("dr83e");
function $1d9cedda3a5081bf$export$23da1d24a38b0bde() {
    const host = window.location.host;
    return host.includes('localhost') || host.includes('.stg.atlassian') || host.includes('jira-dev.com');
}
function $1d9cedda3a5081bf$export$f931afb2c5ecf7c7() {
    const host = window.location.host;
    return host.includes('localhost') && host.includes(':');
}
async function $1d9cedda3a5081bf$export$81bec6e38e8b706b(url, init) {
    try {
        const response = await fetch(url, {
            ...init,
            credentials: 'include',
            headers: {
                'Atl-BFF-Payload-Version': (0, $dr83e.default).packageVersion,
                ...init?.headers
            }
        });
        const jsonResponse = await response.json();
        return {
            status: (0, $4jETc.RequestStatus).COMPLETE,
            data: jsonResponse
        };
    } catch (e) {
        return {
            status: (0, $4jETc.RequestStatus).ERROR,
            error: e,
            data: null
        };
    }
}

});
parcelRegister("dr83e", function(module, exports) {

$parcel$export(module.exports, "default", () => $4553d074abf99d69$export$2e2bcd8739ae039);
const $4553d074abf99d69$var$packageName = "platform-pkg";
const $4553d074abf99d69$var$packageVersion = "0.0.0-use.local";
var $4553d074abf99d69$export$2e2bcd8739ae039 = {
    packageName: $4553d074abf99d69$var$packageName,
    packageVersion: $4553d074abf99d69$var$packageVersion
};

});


parcelRegister("6Tx9o", function(module, exports) {

$parcel$export(module.exports, "useCache", () => $a3b98e022000e430$export$c6e89b6bb9436bc0);

var $gwFzn = parcelRequire("gwFzn");

var $caUKj = parcelRequire("caUKj");
function $a3b98e022000e430$export$c6e89b6bb9436bc0() {
    const { value: { consumer: consumer, cache: cache, cacheKey: cacheKey }, setValue: setValue } = (0, $gwFzn.useContext)((0, $caUKj.BFFContext));
    if (!consumer) throw new Error('BFFContext Consumer is not set');
    const items = (0, $gwFzn.useMemo)(()=>{
        return cache[cacheKey] ?? [];
    }, [
        cache,
        cacheKey
    ]);
    const updateCacheKey = (0, $gwFzn.useCallback)((updatedCacheKey)=>{
        setValue((prev)=>({
                ...prev,
                cacheKey: `${consumer}-${updatedCacheKey}`
            }));
    }, [
        setValue,
        consumer
    ]);
    const addItemsToCache = (0, $gwFzn.useCallback)((items, compareKey = 'cloudId')=>{
        setValue((prev)=>{
            const itemData = prev.cache[cacheKey] ?? [];
            // Overwrite values with matched key if a new value is present
            // This shouldn't be necessary, but it helps act as a safeguard
            // for duplication.
            for (let item of items){
                const replacedItemIndex = itemData.findIndex((i)=>i[compareKey] === item[compareKey]);
                if (replacedItemIndex !== -1) itemData[replacedItemIndex] = item;
                else itemData.push(item);
            }
            return {
                ...prev,
                cache: {
                    ...prev.cache,
                    [cacheKey]: itemData
                }
            };
        });
    }, [
        cacheKey,
        setValue
    ]);
    const clearCache = (0, $gwFzn.useCallback)(()=>{
        setValue((prev)=>({
                ...prev,
                cache: {
                    ...prev.cache,
                    [cacheKey]: []
                }
            }));
    }, [
        cacheKey,
        setValue
    ]);
    return {
        addItemsToCache: addItemsToCache,
        clearCache: clearCache,
        updateCacheKey: updateCacheKey,
        cacheKey: cacheKey,
        items: items
    };
}

});

parcelRegister("7TOrm", function(module, exports) {

$parcel$export(module.exports, "useProductLinks", () => $e49dbd0b56d8db18$export$79322ba781a26ce1);

var $gwFzn = parcelRequire("gwFzn");

var $c5kBK = parcelRequire("c5kBK");

var $lzcvT = parcelRequire("lzcvT");

var $4jETc = parcelRequire("4jETc");

var $1zUVc = parcelRequire("1zUVc");

var $adIf3 = parcelRequire("adIf3");

var $iAFAo = parcelRequire("iAFAo");

var $6Tx9o = parcelRequire("6Tx9o");

var $ik19A = parcelRequire("ik19A");
function $e49dbd0b56d8db18$var$checkIsRecentEndUserActivatedProduct(productType, endUserActivationDate) {
    const parsedEndUserActivationDate = Date.parse(endUserActivationDate || '');
    if (!endUserActivationDate || isNaN(parsedEndUserActivationDate) || ![
        'CONFLUENCE',
        'JIRA_SERVICE_DESK',
        'JIRA_PRODUCT_DISCOVERY'
    ].includes(productType)) return false;
    const days = (0, $1zUVc.daysBetween)(new Date(parsedEndUserActivationDate), new Date());
    return days >= 0 && days <= (0, $4jETc.DAYS_END_USER_ACTIVE_PRODUCT_CONSIDERED_NEW);
}
function $e49dbd0b56d8db18$var$checkIsNewlyAutoProvisioned(autoProvisionDate) {
    let isConsideredNew = false;
    if (autoProvisionDate) {
        const days = (0, $1zUVc.daysBetween)(new Date(autoProvisionDate), new Date());
        isConsideredNew = days >= 0 && days <= (0, $4jETc.DAYS_AUTO_PROVISIONED_ITEM_CONSIDERED_NEW);
    }
    return isConsideredNew;
}
function $e49dbd0b56d8db18$var$checkShouldRemoveJWM(productType) {
    return [
        'JIRA_SOFTWARE',
        'JIRA_PRODUCT_DISCOVERY',
        'JIRA_SERVICE_DESK'
    ].includes(productType);
}
const $e49dbd0b56d8db18$var$flightdeckClient = new (0, $c5kBK.default)('atlassian-navigagtion-bff-data-provider');
function $e49dbd0b56d8db18$export$79322ba781a26ce1({ cloudId: cloudId, orgId: orgId, forceStatic: forceStatic }) {
    const { items: items } = (0, $6Tx9o.useCache)();
    const { setStatus: setStatus } = (0, $ik19A.useStatus)();
    const [fdResponse, setFdResponse] = (0, $gwFzn.useState)(null);
    const [productConfig, setProductConfig] = (0, $gwFzn.useState)(null);
    (0, $gwFzn.useEffect)(()=>{
        const getFlightdeckData = async ()=>{
            try {
                setStatus((0, $4jETc.RequestStatus).LOADING, (0, $4jETc.FLIGHTDECK_REQUEST_STATUS_KEY));
                const fdResponse = await $e49dbd0b56d8db18$var$flightdeckClient.fetchConfigFromFlightDeck({
                    // app-switcher-fe is currently the only valid name that is configured
                    // in Flightdeck
                    name: 'app-switcher-fe',
                    // This should get updated to be based on the supplied consumer
                    // name: `app-global-shortcuts-${consumer}-fe`,
                    dimensions: {
                        environmentType: 'prod',
                        perimeter: (0, $lzcvT.isFedRamp)() ? 'fedramp-moderate' : 'commercial'
                    }
                });
                setFdResponse(fdResponse);
                setStatus((0, $4jETc.RequestStatus).COMPLETE, (0, $4jETc.FLIGHTDECK_REQUEST_STATUS_KEY));
            } catch (e) {
                setStatus((0, $4jETc.RequestStatus).ERROR, (0, $4jETc.FLIGHTDECK_REQUEST_STATUS_KEY));
            }
        };
        if (!fdResponse && !forceStatic) getFlightdeckData();
    }, [
        fdResponse,
        setStatus,
        forceStatic
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (!fdResponse) return;
        const config = {};
        for (const product of fdResponse.products){
            const { apsKey: apsKey, tcsProductKey: tcsProductKey, siteUrlSuffix: siteUrlSuffix, displayName: displayName, rebrandedDisplayName: rebrandedDisplayName, subtitle: subtitle, ordinal: ordinal, iconKey: iconKey, rebrandedIconKey: rebrandedIconKey } = product;
            config[apsKey] = {
                key: !!tcsProductKey ? tcsProductKey : apsKey.toLowerCase(),
                siteUrlSuffix: siteUrlSuffix,
                ordinal: ordinal,
                label: (0, $iAFAo.formatText)(displayName),
                rebrandedLabel: rebrandedDisplayName && (0, $iAFAo.formatText)(rebrandedDisplayName),
                description: (0, $iAFAo.formatText)(subtitle),
                iconKey: iconKey,
                rebrandedIconKey: rebrandedIconKey
            };
            // TODO: remove this once Asset app becomes standalone app
            if (apsKey === 'JIRA_SERVICE_DESK' && !config[0, $4jETc.ASSETS_APP_KEY]) config[0, $4jETc.ASSETS_APP_KEY] = {
                key: (0, $4jETc.ASSETS_APP_KEY),
                siteUrlSuffix: '/jira/assets',
                ordinal: ordinal + 0.1,
                label: (0, $iAFAo.formatText)('Assets'),
                iconKey: 'assets'
            };
        }
        setProductConfig(config);
    }, [
        fdResponse
    ]);
    const getProductLinkForItem = (0, $gwFzn.useCallback)((productType, siteUrl, productUrl)=>{
        if (productUrl) return productUrl;
        const siteSuffix = productConfig?.[productType]?.siteUrlSuffix;
        return `${siteUrl}${siteSuffix}`;
    }, [
        productConfig
    ]);
    const productLinks = (0, $gwFzn.useMemo)(()=>{
        const products = {};
        const shouldRemoveJWM = items.some((item)=>{
            return (item.availableProducts || []).some(({ productType: productType })=>$e49dbd0b56d8db18$var$checkShouldRemoveJWM(productType));
        });
        items.forEach((item)=>{
            const { availableProducts: availableProducts = [], cloudId: cachedItemCloudId, avatar: avatar, url: siteUrl, displayName: displayName, org: org } = item;
            // only apply org level filtering if org data is available
            if (org && orgId && org.id !== orgId) return;
            availableProducts.forEach((product)=>{
                const { autoProvisionDate: autoProvisionDate, companyHubName: companyHubName, isCompanyHubPublishedAndPremium: isCompanyHubPublishedAndPremium, endUserActivationDate: endUserActivationDate, url: productUrl } = product;
                let { productType: productType } = product;
                const isExcludeJiraBusiness = productType === 'JIRA_BUSINESS' && !shouldRemoveJWM;
                // if a site has JWM only and no other Jiras, JWM needs to appear under "Jira"
                // to ensure that this happens, we set JSM's productType to 'JIRA_SOFTWARE'
                // this will ensure that JWM is not removed, even if another site has JSW/JPD/JSM
                if (isExcludeJiraBusiness) productType = 'JIRA_SOFTWARE';
                if (!products[productType]) products[productType] = [];
                if (!isExcludeJiraBusiness) products[productType].push({
                    product: product,
                    isCurrentSite: Boolean(cachedItemCloudId) && cloudId?.toLowerCase() === cachedItemCloudId?.toLowerCase(),
                    isCompanyHubPublishedAndPremium: isCompanyHubPublishedAndPremium,
                    companyHubName: companyHubName,
                    shouldShowNewLozenge: $e49dbd0b56d8db18$var$checkIsRecentEndUserActivatedProduct(productType, endUserActivationDate) || productType !== 'CONFLUENCE' && $e49dbd0b56d8db18$var$checkIsNewlyAutoProvisioned(autoProvisionDate),
                    shouldShowTryLozenge: productType === 'CONFLUENCE' && $e49dbd0b56d8db18$var$checkIsNewlyAutoProvisioned(autoProvisionDate),
                    autoProvisionDate: autoProvisionDate,
                    displayName: displayName,
                    url: getProductLinkForItem(productType, siteUrl, productUrl),
                    avatar: avatar,
                    cloudId: cachedItemCloudId
                });
            });
        });
        return (0, $adIf3.sortArraysInObject)(products, (a, b)=>{
            return (0, $iAFAo.sortAlphabetically)('asc')(a.displayName, b.displayName);
        });
    }, [
        items,
        orgId,
        cloudId,
        getProductLinkForItem
    ]);
    return {
        productLinks: productLinks
    };
}

});
parcelRegister("1zUVc", function(module, exports) {

$parcel$export(module.exports, "daysBetween", () => $4c257adbcfd5a3a3$export$416492d1a5f46c79);
const $4c257adbcfd5a3a3$var$MILLISECONDS_IN_A_DAY = 86400000;
function $4c257adbcfd5a3a3$export$416492d1a5f46c79(firstDate, secondDate) {
    if (!$4c257adbcfd5a3a3$var$isValidDate(firstDate) || !$4c257adbcfd5a3a3$var$isValidDate(secondDate)) return -1;
    const first = firstDate.getTime();
    const second = secondDate.getTime();
    const millisecondsBetween = Math.abs(second - first);
    return Math.round(millisecondsBetween / $4c257adbcfd5a3a3$var$MILLISECONDS_IN_A_DAY);
}
// https://stackoverflow.com/questions/643782/how-to-check-whether-an-object-is-a-date/44198641#44198641
function $4c257adbcfd5a3a3$var$isValidDate(date) {
    return date && Object.prototype.toString.call(date) === '[object Date]' && !isNaN(date);
}

});

parcelRegister("adIf3", function(module, exports) {

$parcel$export(module.exports, "sortArraysInObject", () => $c62ed403d6258f10$export$3e8bbf689f8e6cad);
function $c62ed403d6258f10$export$3e8bbf689f8e6cad(record, sortFunction) {
    for(const key in record)if (Array.isArray(record[key])) record[key].sort(sortFunction); // Sorts alphabetically or numerically by default
    return record;
}

});

parcelRegister("iAFAo", function(module, exports) {

$parcel$export(module.exports, "formatText", () => $abc574e5bd82b638$export$905fe28a7c283e1d);
$parcel$export(module.exports, "sortAlphabetically", () => $abc574e5bd82b638$export$60f5d4abb43a14b3);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");
const $abc574e5bd82b638$export$905fe28a7c283e1d = (text)=>{
    return typeof text === 'string' ? text : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
        ...text
    });
};
const $abc574e5bd82b638$export$60f5d4abb43a14b3 = (direction)=>(a, b)=>{
        const aLower = a.toLowerCase();
        const bLower = b.toLowerCase();
        if (direction === 'asc') return aLower.localeCompare(bLower);
        return bLower.localeCompare(aLower);
    };

});

parcelRegister("ik19A", function(module, exports) {

$parcel$export(module.exports, "useStatus", () => $745446d53837e3a6$export$53cc6abb6942ce72);

var $gwFzn = parcelRequire("gwFzn");

var $4jETc = parcelRequire("4jETc");

var $caUKj = parcelRequire("caUKj");
function $745446d53837e3a6$export$53cc6abb6942ce72() {
    const { setValue: setValue, value: { status: status }, currentLoadingRequests: currentLoadingRequests, updateCurrentLoadingRequests: updateCurrentLoadingRequests } = (0, $gwFzn.useContext)((0, $caUKj.BFFContext));
    const isInitializing = (0, $gwFzn.useMemo)(()=>status === (0, $4jETc.RequestStatus).INIT, [
        status
    ]);
    const isComplete = (0, $gwFzn.useMemo)(()=>status === (0, $4jETc.RequestStatus).COMPLETE, [
        status
    ]);
    const isError = (0, $gwFzn.useMemo)(()=>status === (0, $4jETc.RequestStatus).ERROR, [
        status
    ]);
    const isLoading = (0, $gwFzn.useMemo)(()=>status === (0, $4jETc.RequestStatus).LOADING, [
        status
    ]);
    const isLoaded = (0, $gwFzn.useMemo)(()=>status !== (0, $4jETc.RequestStatus).LOADING, [
        status
    ]);
    // Globally update the status based on the request queue for the BFF
    (0, $gwFzn.useEffect)(()=>{
        if (!currentLoadingRequests.length && status === (0, $4jETc.RequestStatus).LOADING) // Ensure that the error state remains if it was previously set
        setValue((prev)=>{
            if (prev.status === (0, $4jETc.RequestStatus).ERROR) return prev;
            return {
                ...prev,
                status: (0, $4jETc.RequestStatus).COMPLETE
            };
        });
    }, [
        currentLoadingRequests,
        setValue,
        status
    ]);
    // Globally manage the request queue of any calls to the BFF
    const setStatus = (0, $gwFzn.useCallback)((newStatus, integratingComponent)=>{
        if (newStatus === (0, $4jETc.RequestStatus).LOADING && integratingComponent) updateCurrentLoadingRequests(integratingComponent, (0, $4jETc.RequestStatus).LOADING);
        if (newStatus === (0, $4jETc.RequestStatus).COMPLETE) {
            if (integratingComponent) updateCurrentLoadingRequests(integratingComponent, (0, $4jETc.RequestStatus).COMPLETE);
        }
        if (newStatus === (0, $4jETc.RequestStatus).ERROR) {
            if (integratingComponent) updateCurrentLoadingRequests(integratingComponent, (0, $4jETc.RequestStatus).ERROR);
        }
        // Don't allow the status to be marked as anything other than ERROR
        // if an error is pre-existing
        setValue((prev)=>{
            if (prev.status === (0, $4jETc.RequestStatus).ERROR) return prev;
            return {
                ...prev,
                status: newStatus === (0, $4jETc.RequestStatus).ERROR ? (0, $4jETc.RequestStatus).ERROR : (0, $4jETc.RequestStatus).LOADING
            };
        });
    }, [
        updateCurrentLoadingRequests,
        setValue
    ]);
    return {
        status: status,
        isInitializing: isInitializing,
        isComplete: isComplete,
        isError: isError,
        isLoading: isLoading,
        isLoaded: isLoaded,
        setStatus: setStatus
    };
}

});


parcelRegister("cdX3N", function(module, exports) {

$parcel$export(module.exports, "useURLBuilder", () => $e5af1279e152c705$export$3748aab334e7d372);

var $gwFzn = parcelRequire("gwFzn");

var $4jETc = parcelRequire("4jETc");

var $6lFYf = parcelRequire("6lFYf");

var $6Tx9o = parcelRequire("6Tx9o");

var $7hl58 = parcelRequire("7hl58");
var $e5af1279e152c705$var$BFFEndpointsEnum = /*#__PURE__*/ function(BFFEndpointsEnum) {
    BFFEndpointsEnum["AVAILABLE_PRODUCTS"] = "/gateway/api/app-switcher/api/available-products";
    BFFEndpointsEnum["SUGGESTIONS"] = "/gateway/api/app-switcher/api/universal-create/v1/suggestions";
    return BFFEndpointsEnum;
}($e5af1279e152c705$var$BFFEndpointsEnum || {});
function $e5af1279e152c705$export$3748aab334e7d372({ cloudId: cloudId }) {
    const { consumer: consumer } = (0, $7hl58.useConsumer)();
    const { items: cachedItems } = (0, $6Tx9o.useCache)();
    const buildUCRecommendationURL = (0, $gwFzn.useCallback)(({ product: product, orgId: orgId })=>{
        const baseUrl = "/gateway/api/app-switcher/api/universal-create/v1/suggestions";
        const url = new URL(`${getHomeUrl()}${baseUrl}`);
        const searchParams = new URLSearchParams();
        const queryParams = {
            tenantid: cloudId,
            product: product,
            orgid: orgId,
            source: consumer
        };
        Object.entries(queryParams).forEach(([key, value])=>{
            if (value) searchParams.append(key, value);
        });
        // Append search params to URL
        url.search = searchParams.toString();
        return url.toString();
    }, [
        consumer,
        cloudId
    ]);
    const buildProductShortcutURL = (0, $gwFzn.useCallback)(({ requestedAPSKeys: requestedAPSKeys, baseUrl: baseUrl })=>{
        baseUrl = baseUrl ?? "/gateway/api/app-switcher/api/available-products";
        const availableKVPairs = requestedAPSKeys.filter((itemKey)=>!cachedItems.some((cachedItem)=>cachedItem.availableProducts.some((cap)=>cap.productType === itemKey))).map((itemKey)=>[
                'products',
                itemKey
            ]);
        // No point in building a URL if there are no items to fetch and the cache is already populated
        if (!availableKVPairs.length && cachedItems.length > 0) return '';
        // Exclude items that have already been cached
        // and convert to URL query string
        // TODO: return it to the generated combinations:
        // const queryValues = new URLSearchParams(availableKVPairs);
        const queryValues = '';
        return `${getHomeUrl()}${baseUrl}?${queryValues}`;
    }, [
        cachedItems
    ]);
    const buildURL = (0, $gwFzn.useCallback)(({ requestedAPSKeys: requestedAPSKeys, baseUrl: baseUrl })=>{
        let url = '';
        if (baseUrl) url = `${getHomeUrl()}${baseUrl}`;
        // Consumer specific URL building implementations happen here
        switch(consumer){
            case (0, $4jETc.BFFConsumerEnum).GLOBAL_SHORTCUTS:
                url = buildProductShortcutURL({
                    requestedAPSKeys: requestedAPSKeys
                });
                break;
            case (0, $4jETc.BFFConsumerEnum).GLOBAL_SIDE_NAVIGATION:
                url = buildProductShortcutURL({
                    requestedAPSKeys: requestedAPSKeys
                });
                break;
        }
        if (!url) return url;
        // Append the consumer to the URL
        const formattedUrl = new URL(url);
        const updatedParams = new URLSearchParams(formattedUrl.search);
        if (consumer) updatedParams.append('source', consumer);
        if (cloudId) updatedParams.append('tenantid', cloudId);
        return `${formattedUrl.origin}${formattedUrl.pathname}?${updatedParams}`;
    }, [
        buildProductShortcutURL,
        consumer,
        cloudId
    ]);
    const getHomeUrl = ()=>{
        if ((0, $6lFYf.isLocalHost)()) return 'https://home.stg.atlassian.com';
        return new URL(window.location.href).origin;
    };
    return {
        buildURL: buildURL,
        buildProductShortcutURL: buildProductShortcutURL,
        buildUCRecommendationURL: buildUCRecommendationURL
    };
}

});
parcelRegister("7hl58", function(module, exports) {

$parcel$export(module.exports, "useConsumer", () => $9c1427a12622d9c5$export$33062d550933de6f);

var $gwFzn = parcelRequire("gwFzn");

var $caUKj = parcelRequire("caUKj");
function $9c1427a12622d9c5$export$33062d550933de6f() {
    const { value: { consumer: consumer } } = (0, $gwFzn.useContext)((0, $caUKj.BFFContext));
    return {
        consumer: consumer
    };
}

});



parcelRegister("culkJ", function(module, exports) {

$parcel$export(module.exports, "Products", () => $062f3565ea2f6981$export$92e44ea1079b9ec6);
$parcel$export(module.exports, "ANALYTICS_CHANNEL", () => $062f3565ea2f6981$export$85183a312807388d);
/**
 * Product keys as defined in flight-deck.
 * https://bitbucket.org/atlassian/flight-deck/src/master/packages/integrations/twp-switch-to-products/contrib/
 */ var $062f3565ea2f6981$export$92e44ea1079b9ec6 = /*#__PURE__*/ function(Products) {
    // ATLAS_* - Need to be standalone apps to sit in this space
    Products["ATLAS_HOME"] = "ATLAS_HOME";
    Products["ATLAS_GOALS"] = "GOALS";
    Products["ATLAS_TEAMS"] = "TEAMS";
    Products["ATLAS_HUB"] = "ATLAS_HUB";
    Products["ANALYTICS"] = "ANALYTICS";
    Products["ASSETS"] = "ASSETS";
    Products["BITBUCKET"] = "BITBUCKET";
    Products["COMPASS"] = "COMPASS";
    Products["FOCUS"] = "mercury";
    Products["STUDIO"] = "STUDIO";
    Products["OPSGENIE"] = "OPSGENIE";
    Products["JIRA_SERVICE_MANAGEMENT"] = "JIRA_SERVICE_DESK";
    Products["JIRA_PRODUCT_DISCOVERY"] = "JIRA_PRODUCT_DISCOVERY";
    Products["JIRA_SOFTWARE"] = "JIRA_SOFTWARE";
    Products["CONFLUENCE"] = "CONFLUENCE";
    Products["LOOM"] = "LOOM";
    Products["PROJECTS"] = "PROJECTS";
    Products["TALENT"] = "TALENT";
    Products["TRELLO"] = "TRELLO";
    return Products;
}({});
const $062f3565ea2f6981$export$85183a312807388d = 'navigation';

});

parcelRegister("fqJ57", function(module, exports) {

$parcel$export(module.exports, "GlobalShortcutsWithIntlProvider", () => $a5ea78601091ee04$export$6b89dea1a4334953);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $keVvA = parcelRequire("keVvA");

var $7FdE1 = parcelRequire("7FdE1");

var $6h453 = parcelRequire("6h453");
const $a5ea78601091ee04$var$fetchMessagesForLocale = async (locale)=>{
    try {
        // Fallback to the generic locale if specified one is not found
        const languageLocale = locale in (0, $6h453.asyncLanguages) ? locale : locale.split(/[-_]/)[0] || '';
        // Dynamic import of the locale file
        const localeMessages = await (0, $6h453.asyncLanguages)[languageLocale]?.();
        return localeMessages?.default ?? (0, $7FdE1.default);
    } catch (e) {
    // ignore
    }
    return 0, $7FdE1.default;
};
const $a5ea78601091ee04$export$6b89dea1a4334953 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $keVvA.default), {
        defaultMessages: (0, $7FdE1.default),
        loaderFn: $a5ea78601091ee04$var$fetchMessagesForLocale,
        children: children
    });
};

});
parcelRegister("7FdE1", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $a39680e968b16aaa$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $a39680e968b16aaa$export$2e2bcd8739ae039 = {
    'navigation.global-shortcuts.all-sites': 'All sites',
    'navigation.global-shortcuts.apps.align': 'Align',
    'navigation.global-shortcuts.apps.analytics': 'Analytics',
    'navigation.global-shortcuts.apps.assets': 'Assets',
    'navigation.global-shortcuts.apps.bitbucket': 'Bitbucket',
    'navigation.global-shortcuts.apps.company-hub': 'Company Hub',
    'navigation.global-shortcuts.apps.compass': 'Compass',
    'navigation.global-shortcuts.apps.confluence': 'Confluence',
    'navigation.global-shortcuts.apps.focus': 'Focus',
    'navigation.global-shortcuts.apps.goals': 'Goals',
    'navigation.global-shortcuts.apps.home': 'Home',
    'navigation.global-shortcuts.apps.jira': 'Jira',
    'navigation.global-shortcuts.apps.jira-product-discovery': 'Jira Product Discovery',
    'navigation.global-shortcuts.apps.jira-service-management': 'Jira Service Management',
    'navigation.global-shortcuts.apps.loom': 'Loom',
    'navigation.global-shortcuts.apps.opsgenie': 'Opsgenie',
    'navigation.global-shortcuts.apps.projects': 'Projects',
    'navigation.global-shortcuts.apps.studio': 'Studio',
    'navigation.global-shortcuts.apps.talent': 'Talent',
    'navigation.global-shortcuts.apps.teams': 'Teams',
    'navigation.global-shortcuts.apps.trello': 'Trello',
    'navigation.global-shortcuts.menu-expand-item.close-button-aria-label': 'Close',
    'navigation.global-shortcuts.menu-expand-item.site-aria-label': '{name} site',
    'navigation.global-shortcuts.menu-link-item.disabled-item-aria-label': '(currently unavailable)',
    'navigation.global-shortcuts.menu-link-item.link-external-item-label': 'Open external link icon',
    'navigation.global-shortcuts.menu-link-item.loading-item-aria-label': '(loading)',
    'navigation.global-shortcuts.menu-loading-item.loading-item-aria-label': '(loading)',
    'navigation.global-shortcuts.shortcut-action.open-menu-label': 'open menu',
    'navigation.global-shortcuts.shortcut-link-item.aria-label': '{appName}{siteName}',
    'navigation.global-shortcuts.sites': '{productName} sites'
};

});

parcelRegister("6h453", function(module, exports) {

$parcel$export(module.exports, "asyncLanguages", () => $b8f2a3af0ad05925$export$3770c7a7737d463c);

























const $b8f2a3af0ad05925$export$3770c7a7737d463c = {
    cs: ()=>(parcelRequire("eqnTp")),
    da: ()=>(parcelRequire("h0uG3")),
    de: ()=>(parcelRequire("kYW2p")),
    'en-GB': ()=>(parcelRequire("8oTvm")),
    'en-ZZ': ()=>(parcelRequire("71ck4")),
    en: ()=>Promise.resolve((parcelRequire("7FdE1"))),
    es: ()=>(parcelRequire("hS1t3")),
    fi: ()=>(parcelRequire("inwbW")),
    fr: ()=>(parcelRequire("i0r54")),
    hu: ()=>(parcelRequire("lIg5P")),
    it: ()=>(parcelRequire("bIBgL")),
    ja: ()=>(parcelRequire("gO8LQ")),
    ko: ()=>(parcelRequire("b6EHK")),
    nb: ()=>(parcelRequire("5gIdF")),
    nl: ()=>(parcelRequire("5UWEg")),
    pl: ()=>(parcelRequire("bc86s")),
    'pt-BR': ()=>(parcelRequire("bfgDA")),
    ru: ()=>(parcelRequire("hnVzN")),
    sv: ()=>(parcelRequire("1sYgE")),
    th: ()=>(parcelRequire("l6SQF")),
    tr: ()=>(parcelRequire("dViW3")),
    uk: ()=>(parcelRequire("g2ejT")),
    vi: ()=>(parcelRequire("kFQm4")),
    zh_TW: ()=>(parcelRequire("avEWD")),
    zh: ()=>(parcelRequire("3y96v"))
};

});
parcelRegister("eqnTp", function(module, exports) {

let $a80606f9fed6285c$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $a80606f9fed6285c$var$load("cPBME").then(()=>parcelRequire('br2f9'));

});

parcelRegister("h0uG3", function(module, exports) {

let $c61a3ba2726b3420$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $c61a3ba2726b3420$var$load("b2Scm").then(()=>parcelRequire('5T7BQ'));

});

parcelRegister("kYW2p", function(module, exports) {

let $f4666e57b54eb389$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $f4666e57b54eb389$var$load("iypHn").then(()=>parcelRequire('f72Ys'));

});

parcelRegister("8oTvm", function(module, exports) {

let $61db9eb797588d8c$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $61db9eb797588d8c$var$load("03aeW").then(()=>parcelRequire('9Uzok'));

});

parcelRegister("71ck4", function(module, exports) {

let $51c22f6ccc8e5128$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $51c22f6ccc8e5128$var$load("kiPGm").then(()=>parcelRequire('hFCKc'));

});

parcelRegister("hS1t3", function(module, exports) {

let $d0289e3ea5e0bde3$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $d0289e3ea5e0bde3$var$load("hoJCV").then(()=>parcelRequire('kosLT'));

});

parcelRegister("inwbW", function(module, exports) {

let $d613588b23c07d0a$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $d613588b23c07d0a$var$load("1YIhB").then(()=>parcelRequire('ggDJR'));

});

parcelRegister("i0r54", function(module, exports) {

let $d1bd3bc1353fd985$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $d1bd3bc1353fd985$var$load("8TdZh").then(()=>parcelRequire('4f1t8'));

});

parcelRegister("lIg5P", function(module, exports) {

let $fcea30c8e1de409c$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $fcea30c8e1de409c$var$load("fIJ95").then(()=>parcelRequire('3xm6B'));

});

parcelRegister("bIBgL", function(module, exports) {

let $8880b6ae64d41630$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $8880b6ae64d41630$var$load("dnBvs").then(()=>parcelRequire('abc2w'));

});

parcelRegister("gO8LQ", function(module, exports) {

let $c3c81e88ee56c096$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $c3c81e88ee56c096$var$load("55ryq").then(()=>parcelRequire('iOsEl'));

});

parcelRegister("b6EHK", function(module, exports) {

let $815fd45a5d5afe8e$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $815fd45a5d5afe8e$var$load("avghK").then(()=>parcelRequire('aIqdH'));

});

parcelRegister("5gIdF", function(module, exports) {

let $3d60bf6933bb078c$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $3d60bf6933bb078c$var$load("ctqAV").then(()=>parcelRequire('6B9u2'));

});

parcelRegister("5UWEg", function(module, exports) {

let $44efad16eed582cd$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $44efad16eed582cd$var$load("9FaVS").then(()=>parcelRequire('bZefw'));

});

parcelRegister("bc86s", function(module, exports) {

let $826719cce6368371$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $826719cce6368371$var$load("kmzYt").then(()=>parcelRequire('kzj9p'));

});

parcelRegister("bfgDA", function(module, exports) {

let $82fe0048db7f486e$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $82fe0048db7f486e$var$load("7uS3Z").then(()=>parcelRequire('5JjoD'));

});

parcelRegister("hnVzN", function(module, exports) {

let $ca813f22a32f0547$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $ca813f22a32f0547$var$load("gYg2y").then(()=>parcelRequire('kJ9vR'));

});

parcelRegister("1sYgE", function(module, exports) {

let $111727dcc231a979$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $111727dcc231a979$var$load("89CZ1").then(()=>parcelRequire('vKazA'));

});

parcelRegister("l6SQF", function(module, exports) {

let $f5e4b44361509073$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $f5e4b44361509073$var$load("6nK39").then(()=>parcelRequire('3GtCy'));

});

parcelRegister("dViW3", function(module, exports) {

let $a22f4961fe2ce020$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $a22f4961fe2ce020$var$load("hWNfo").then(()=>parcelRequire('72BhT'));

});

parcelRegister("g2ejT", function(module, exports) {

let $bac7f0d867bbb8e4$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $bac7f0d867bbb8e4$var$load("8UuQQ").then(()=>parcelRequire('6yNb3'));

});

parcelRegister("kFQm4", function(module, exports) {

let $f0d03f97aab578a9$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $f0d03f97aab578a9$var$load("6BkMx").then(()=>parcelRequire('74VfG'));

});

parcelRegister("avEWD", function(module, exports) {

let $7a6c8f6937e1be31$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $7a6c8f6937e1be31$var$load("7fKy1").then(()=>parcelRequire('hP4wC'));

});

parcelRegister("3y96v", function(module, exports) {

let $295b9beec9bc439d$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $295b9beec9bc439d$var$load("dNXO5").then(()=>parcelRequire('hc8vA'));

});



parcelRegister("kslv8", function(module, exports) {

$parcel$export(module.exports, "ImageFromUrl", () => $dc05a67facdb070f$export$8ce0ddc4c9a614d4);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $gj7hi = parcelRequire("gj7hi");
const $dc05a67facdb070f$export$8ce0ddc4c9a614d4 = ({ src: src, alt: alt, fallback: fallback, testId: testId })=>{
    const [hasError, setHasError] = (0, $gwFzn.useState)(false);
    if (!src || hasError) return fallback;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gj7hi.default), {
        src: src,
        alt: alt,
        onError: ()=>{
            setHasError(true);
        },
        testId: testId
    });
};

});

parcelRegister("g2RNl", function(module, exports) {

$parcel$export(module.exports, "MenuSkeletonItem", () => $62857df157fde5b7$export$cde35cc9e1359709);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $1Whri = parcelRequire("1Whri");

var $6f0Oj = parcelRequire("6f0Oj");
var $bUlM5 = parcelRequire("bUlM5");
var $1GzhS = parcelRequire("1GzhS");

var $kpYGL = parcelRequire("kpYGL");
const $62857df157fde5b7$var$DEFAULT_MENU_SKELETON_HEIGHT = 32;
const $62857df157fde5b7$var$DEFAULT_AVATAR_HEIGHT = 20;
const $62857df157fde5b7$var$DEFAULT_CONTENT_HEIGHT = 12;
const $62857df157fde5b7$var$DEFAULT_BORDER_RADIUS = 4;
const $62857df157fde5b7$var$styles = {
    root: "_4t3izwfg _1bsb1osq _ca0qze3t _n3tdze3t _19bv1b66 _u5f31b66",
    avatar: "_19bvv77o"
};
const $62857df157fde5b7$export$cde35cc9e1359709 = ({ avatarHeight: avatarHeight = $62857df157fde5b7$var$DEFAULT_AVATAR_HEIGHT, contentHeight: contentHeight = $62857df157fde5b7$var$DEFAULT_CONTENT_HEIGHT })=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1GzhS.default), {
        xcss: (0, $1Whri.cx)($62857df157fde5b7$var$styles.root),
        alignBlock: "center",
        children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $bUlM5.default), {
            alignItems: "center",
            gap: "space.050",
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                    xcss: (0, $1Whri.cx)($62857df157fde5b7$var$styles.avatar),
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $kpYGL.default), {
                        width: avatarHeight,
                        height: avatarHeight,
                        borderRadius: $62857df157fde5b7$var$DEFAULT_BORDER_RADIUS
                    })
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $kpYGL.default), {
                    width: "100%",
                    height: contentHeight,
                    borderRadius: "0"
                })
            ]
        })
    });
};

});

parcelRegister("5hYae", function(module, exports) {

$parcel$export(module.exports, "ShortcutMenuItem", () => $5a702e671347a15f$export$af94fce1535255cc);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $7TH2w = parcelRequire("7TH2w");

var $inPa6 = parcelRequire("inPa6");

var $4jETc = parcelRequire("4jETc");

var $culkJ = parcelRequire("culkJ");

var $3liD5 = parcelRequire("3liD5");

var $6QyyP = parcelRequire("6QyyP");

var $exCAi = parcelRequire("exCAi");

var $gSkPq = parcelRequire("gSkPq");
function $5a702e671347a15f$export$af94fce1535255cc({ shortcut: shortcut, status: status, expandItems: expandItems, forceStatic: forceStatic, promotedItem: promotedItem, siteName: siteName }) {
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const analyticsName = (0, $gwFzn.useMemo)(()=>{
        if (typeof shortcut.label === 'string') return shortcut.label;
        if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).isValidElement(shortcut.label)) return (0, $3liD5.extractNameFromLabel)(shortcut.label);
    }, [
        shortcut.label
    ]);
    const siteNameAriaLabel = siteName ? ` (${siteName})` : '';
    /**
   * If the data provider is being initialised or loading, we want to display a placeholder item with a spinner.
   */ const loading = (0, $gwFzn.useMemo)(()=>!!(!forceStatic && status && (status === (0, $4jETc.RequestStatus).INIT || status === (0, $4jETc.RequestStatus).LOADING)), [
        status,
        forceStatic
    ]);
    /**
   * Set disabled state based on what we know at this point
   * from whether we are forcing static rendering and the status of the BFF request.
   * If we have more conditions received from the BFF in the future (such as permissions), we can account for those here too.
   */ const disabled = (0, $gwFzn.useMemo)(()=>{
        // If forceStatic is explicitly set to true, do not disable the item
        if (forceStatic) return false;
        // Do not explicitly disable links that have empty URLs, because we don't want to display them at all
        if (shortcut?.fallbackUrl && shortcut?.fallbackUrl() === '') return false;
        // Only show disabled state when the BFF request is complete and fails
        if (status === (0, $4jETc.RequestStatus).ERROR) return true;
        if (forceStatic === undefined) return false;
        return !forceStatic;
    }, [
        forceStatic,
        shortcut,
        status
    ]);
    /**
   * An event to pass down to the inner menu item component (MenuLinkItem or MenuExpandItem) to be called when the item is disabled.
   * This allows the inner components to handle further disabling conditions within themselves if applicable,
   * and optionally pass up a reason for the disabled state determined within itself.
   * If no reason is passed, we check against what we know here from the data received from the BFF.
   */ const onDisable = (0, $gwFzn.useCallback)((reason)=>{
        // Do not fire analytics event until loading is complete
        if (!status || status === (0, $4jETc.RequestStatus).INIT || status === (0, $4jETc.RequestStatus).LOADING) return;
        // This currently covers reasons like request errors.
        // If the BFF gives us more information in the future (such as permissions), that should be accounted for here too.
        const bffReason = status !== (0, $4jETc.RequestStatus).COMPLETE ? status : undefined;
        createAnalyticsEvent({
            eventType: (0, $7TH2w.UI_EVENT_TYPE),
            action: 'disabled',
            actionSubject: 'button',
            actionSubjectId: 'globalNavigation',
            attributes: {
                name: analyticsName,
                reason: reason ?? bffReason
            }
        }).fire((0, $culkJ.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        analyticsName,
        status
    ]);
    const Component = shortcut?.component;
    if (Component) return /*#__PURE__*/ (0, $7UHDa.jsx)(Component, {
        onClick: ()=>{
            (0, $exCAi.fireMenuLinkItemClickAnalyticsEvent)(createAnalyticsEvent, analyticsName);
        }
    });
    if (expandItems && expandItems?.length > 0) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6QyyP.MenuExpandItem), {
        analyticsName: analyticsName,
        icon: shortcut.icon,
        label: shortcut.label,
        items: expandItems,
        disabled: disabled,
        onDisable: onDisable,
        promotedItem: promotedItem,
        loading: loading
    }, shortcut.key);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $exCAi.MenuLinkItem), {
        analyticsName: analyticsName,
        disabled: disabled,
        apsKey: shortcut.apsKey,
        icon: shortcut.icon,
        url: shortcut.url || shortcut?.fallbackUrl?.(),
        label: shortcut.label,
        onDisable: onDisable,
        loading: loading,
        actions: shortcut.actions,
        ariaLabel: formatMessage((0, $gSkPq.messages).menuLinkItemAriaLabel, {
            appName: analyticsName,
            siteName: siteNameAriaLabel
        })
    }, shortcut.key);
}

});
parcelRegister("3liD5", function(module, exports) {

$parcel$export(module.exports, "extractNameFromLabel", () => $24dd59e8d10e2ca7$export$56d01f50df37ce79);

var $gwFzn = parcelRequire("gwFzn");
const $24dd59e8d10e2ca7$export$bc8c852df998b819 = (item)=>{
    return item.fallbackUrl !== undefined;
};
const $24dd59e8d10e2ca7$export$60f5d4abb43a14b3 = (direction)=>(a, b)=>{
        const aLower = a.toLowerCase();
        const bLower = b.toLowerCase();
        if (direction === 'asc') return aLower.localeCompare(bLower);
        return bLower.localeCompare(aLower);
    };
function $24dd59e8d10e2ca7$export$56d01f50df37ce79(label) {
    if (!label?.props?.children && !label?.props?.defaultMessage) return undefined;
    if (typeof label?.props?.children === 'string') return label?.props?.children;
    else if (typeof label?.props?.defaultMessage === 'string') return label?.props?.defaultMessage;
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).isValidElement(label.props.children)) return $24dd59e8d10e2ca7$export$56d01f50df37ce79(label.props.children);
}

});

parcelRegister("6QyyP", function(module, exports) {

$parcel$export(module.exports, "MenuExpandItem", () => $0d4f155f095a22b6$export$3b6395e687b929ba);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $7TH2w = parcelRequire("7TH2w");

var $inPa6 = parcelRequire("inPa6");

var $ccHMk = parcelRequire("ccHMk");

var $1Whri = parcelRequire("1Whri");

var $iI2ST = parcelRequire("iI2ST");

var $h0OZ6 = parcelRequire("h0OZ6");
var $580cg = parcelRequire("580cg");
var $f4c6t = parcelRequire("f4c6t");

var $9kbAI = parcelRequire("9kbAI");

var $gdv5Z = parcelRequire("gdv5Z");

var $culkJ = parcelRequire("culkJ");

var $3liD5 = parcelRequire("3liD5");

var $b7uWl = parcelRequire("b7uWl");

var $exCAi = parcelRequire("exCAi");

var $lAokq = parcelRequire("lAokq");

var $89S1K = parcelRequire("89S1K");

var $l4OFZ = parcelRequire("l4OFZ");
const $0d4f155f095a22b6$var$styles = {
    root: "_otyr1b66"
};
const $0d4f155f095a22b6$export$3b6395e687b929ba = ({ icon: icon, label: label, analyticsName: analyticsName, items: items, disabled: disabled, onDisable: onDisable, promotedItem: promotedItem, loading: loading })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [isOpen, setIsOpen] = (0, $gwFzn.useState)(false);
    const closeFlyout = (0, $gwFzn.useCallback)(()=>setIsOpen(false), []);
    const toggleFlyout = (0, $gwFzn.useCallback)(()=>{
        createAnalyticsEvent({
            eventType: (0, $7TH2w.UI_EVENT_TYPE),
            action: 'clicked',
            actionSubject: 'globalNavigation',
            actionSubjectId: 'navigationItem',
            attributes: {
                name: analyticsName,
                isExpanding: !isOpen
            }
        }).fire((0, $culkJ.ANALYTICS_CHANNEL));
        setIsOpen((prev)=>!prev);
    }, [
        createAnalyticsEvent,
        analyticsName,
        isOpen
    ]);
    const createLinkItem = (0, $gwFzn.useCallback)((shortcut, index)=>{
        return shortcut.items ? /*#__PURE__*/ (0, $7UHDa.jsx)($0d4f155f095a22b6$export$3b6395e687b929ba, {
            icon: shortcut.icon,
            label: shortcut.label,
            items: shortcut.items,
            disabled: disabled,
            actions: shortcut.actions,
            analyticsName: analyticsName
        }, shortcut?.apsKey ?? `shortcut-${index}`) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $exCAi.MenuLinkItem), {
            apsKey: shortcut.apsKey,
            icon: shortcut.icon,
            url: shortcut.url || shortcut?.fallbackUrl?.(),
            label: shortcut.label,
            disabled: disabled,
            ariaLabel: formatMessage((0, $l4OFZ.messages).siteAriaLabel, {
                name: (0, $3liD5.extractNameFromLabel)(/*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {
                    children: shortcut.label
                }))
            }),
            analyticsName: analyticsName
        }, shortcut?.apsKey ?? `shortcut-${index}`);
    }, [
        disabled,
        formatMessage,
        analyticsName
    ]); // If loading state then show loading placeholder
    if (loading === true) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $lAokq.MenuLoadingItem), {
        icon: icon,
        label: label
    });
    if (disabled) {
        onDisable?.();
        return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $iI2ST.ButtonMenuItem), {
            elemBefore: icon,
            isDisabled: true,
            children: label
        });
    }
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $h0OZ6.FlyoutMenuItem), {
        isOpen: isOpen,
        onOpenChange: setIsOpen,
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $f4c6t.FlyoutMenuItemTrigger), {
                elemBefore: icon,
                onClick: toggleFlyout,
                children: label
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $580cg.FlyoutMenuItemContent), {
                onClose: closeFlyout,
                children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $b7uWl.MenuContent), {
                    heading: label,
                    children: [
                        promotedItem && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $89S1K.MenuSection), {
                            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9kbAI.MenuList), {
                                children: createLinkItem(promotedItem, 1)
                            }, "gas-promoted-sites")
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $89S1K.MenuSection), {
                            label: formatMessage((0, $l4OFZ.messages).allSites),
                            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9kbAI.MenuList), {
                                children: items?.map(createLinkItem)
                            }, "gas-all-sites")
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
                            xcss: (0, $1Whri.cx)($0d4f155f095a22b6$var$styles.root),
                            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $ccHMk.default), {
                                shouldFitContainer: true,
                                appearance: "default",
                                onClick: closeFlyout,
                                children: formatMessage((0, $l4OFZ.messages).closeButtonAriaLabel)
                            })
                        })
                    ]
                })
            })
        ]
    });
};

});
parcelRegister("h0OZ6", function(module, exports) {

$parcel$export(module.exports, "FlyoutMenuItem", () => $bfeec28731cf41b0$export$34e3b4eaa687835);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $6mkwk = parcelRequire("6mkwk");

var $bzNqF = parcelRequire("bzNqF");

var $l5LHO = parcelRequire("l5LHO");

var $jjpBv = parcelRequire("jjpBv");

var $fFwtP = parcelRequire("fFwtP");
const $bfeec28731cf41b0$export$34e3b4eaa687835 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ children: children, id: id, isOpen: isOpenControlled, isDefaultOpen: isDefaultOpen = false, onOpenChange: onOpenChange }, forwardedRef)=>{
    const [isOpen, setIsOpen] = (0, $6mkwk.default)(isOpenControlled, ()=>isDefaultOpen);
    const previousIsOpen = (0, $bzNqF.default)(isOpen);
    (0, $gwFzn.useEffect)(()=>{
        if (previousIsOpen === undefined || previousIsOpen === isOpen) /**
				 * The previous value is `undefined` on initialization, so if it is `undefined` then the value hasn't changed.
				 *
				 * The previous value can be equal to the current one if the component re-renders due to something else changing.
				 *
				 * In both cases the value hasn't changed and we don't want to notify consumers.
				 */ return;
        onOpenChange?.(isOpen);
    }, [
        isOpen,
        onOpenChange,
        previousIsOpen
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fFwtP.IsOpenContext).Provider, {
        value: isOpen,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fFwtP.SetIsOpenContext).Provider, {
            value: setIsOpen,
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $jjpBv.MenuListItem), {
                ref: forwardedRef,
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $l5LHO.Popup), {
                    id: id,
                    isOpen: isOpen,
                    children: children
                })
            })
        })
    });
});

});
parcelRegister("l5LHO", function(module, exports) {

$parcel$export(module.exports, "Popup", () => $9aa4c7c29923f177$export$129a32eedafa97c5);
$parcel$export(module.exports, "PopupTrigger", () => $9aa4c7c29923f177$export$95d4acdbab2fc6ef);
$parcel$export(module.exports, "PopupContent", () => $9aa4c7c29923f177$export$2a2c7ba12d3231e3);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $5Uzw3 = parcelRequire("5Uzw3");

var $ee7An = parcelRequire("ee7An");

var $c0qxy = parcelRequire("c0qxy");

var $iug2J = parcelRequire("iug2J");

var $if5rb = parcelRequire("if5rb");

var $2ED7Q = parcelRequire("2ED7Q");
var $epI1O = parcelRequire("epI1O");

var $caX7N = parcelRequire("caX7N");

var $2cdko = parcelRequire("2cdko");

var $fiAWX = parcelRequire("fiAWX");

var $9Ghf3 = parcelRequire("9Ghf3");
const $9aa4c7c29923f177$var$IsOpenContext = /*#__PURE__*/ (0, $gwFzn.createContext)(false);
const $9aa4c7c29923f177$var$IdContext = /*#__PURE__*/ (0, $gwFzn.createContext)(undefined);
const $9aa4c7c29923f177$var$TriggerRefContext = /*#__PURE__*/ (0, $gwFzn.createContext)(null);
const $9aa4c7c29923f177$var$SetTriggerRefContext = /*#__PURE__*/ (0, $gwFzn.createContext)((0, $ee7An.default));
const $9aa4c7c29923f177$var$EnsureIsInsidePopupContext = /*#__PURE__*/ (0, $gwFzn.createContext)(false);
// Used to ensure popup sub-components are used within a Popup
// and provide a useful error message if not.
const $9aa4c7c29923f177$var$useEnsureIsInsidePopup = ()=>{
    const context = (0, $gwFzn.useContext)($9aa4c7c29923f177$var$EnsureIsInsidePopupContext);
    (0, $5Uzw3.default)(context, 'PopupTrigger and PopupContent components must be used within a Popup');
};
const $9aa4c7c29923f177$export$129a32eedafa97c5 = ({ children: children, id: providedId, isOpen: isOpen = false })=>{
    const [triggerRef, setTriggerRef] = (0, $gwFzn.useState)(null);
    const generatedId = (0, $c0qxy.useId)();
    const id = providedId || generatedId;
    return /*#__PURE__*/ (0, $7UHDa.jsx)($9aa4c7c29923f177$var$EnsureIsInsidePopupContext.Provider, {
        value: true,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)($9aa4c7c29923f177$var$IdContext.Provider, {
            value: id,
            children: /*#__PURE__*/ (0, $7UHDa.jsx)($9aa4c7c29923f177$var$TriggerRefContext.Provider, {
                value: triggerRef,
                children: /*#__PURE__*/ (0, $7UHDa.jsx)($9aa4c7c29923f177$var$SetTriggerRefContext.Provider, {
                    value: setTriggerRef,
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)($9aa4c7c29923f177$var$IsOpenContext.Provider, {
                        value: isOpen,
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2ED7Q.Manager), {
                            children: children
                        })
                    })
                })
            })
        })
    });
};
const $9aa4c7c29923f177$export$95d4acdbab2fc6ef = ({ children: children })=>{
    $9aa4c7c29923f177$var$useEnsureIsInsidePopup();
    const isOpen = (0, $gwFzn.useContext)($9aa4c7c29923f177$var$IsOpenContext);
    const id = (0, $gwFzn.useContext)($9aa4c7c29923f177$var$IdContext);
    const setTriggerRef = (0, $gwFzn.useContext)($9aa4c7c29923f177$var$SetTriggerRefContext);
    const getMergedTriggerRef = (0, $9Ghf3.useGetMemoizedMergedTriggerRef)();
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $epI1O.Reference), {
        children: ({ ref: ref })=>children({
                ref: getMergedTriggerRef(ref, setTriggerRef, isOpen),
                'aria-controls': id,
                'aria-expanded': isOpen,
                'aria-haspopup': true
            })
    });
};
const $9aa4c7c29923f177$var$defaultLayer = 400;
/**
 * Disables popper.js GPU acceleration for this popup.
 * This means only positioning will be used, without any transforms.
 *
 * Performance will be degraded if the popup is expected to move.
 */ const $9aa4c7c29923f177$var$shouldDisableGpuAccelerationModifiers = [
    {
        name: 'computeStyles',
        options: {
            gpuAcceleration: false
        }
    }
];
const $9aa4c7c29923f177$export$2a2c7ba12d3231e3 = ({ xcss: xcss, appearance: inAppearance = 'default', children: children, boundary: boundary, offset: offset, strategy: strategy, onClose: onClose, testId: testId, rootBoundary: rootBoundary = 'viewport', shouldFlip: shouldFlip = true, placement: placement = 'auto', fallbackPlacements: fallbackPlacements, popupComponent: popupComponent, autoFocus: autoFocus = true, zIndex: zIndex = $9aa4c7c29923f177$var$defaultLayer, shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick = false, shouldRenderToParent: inShouldRenderToParent, shouldDisableFocusLock: shouldDisableFocusLock = false, shouldFitContainer: shouldFitContainer, shouldFitViewport: shouldFitViewport, shouldDisableGpuAcceleration: shouldDisableGpuAcceleration = false })=>{
    $9aa4c7c29923f177$var$useEnsureIsInsidePopup();
    const isOpen = (0, $gwFzn.useContext)($9aa4c7c29923f177$var$IsOpenContext);
    const id = (0, $gwFzn.useContext)($9aa4c7c29923f177$var$IdContext);
    const triggerRef = (0, $gwFzn.useContext)($9aa4c7c29923f177$var$TriggerRefContext);
    const { appearance: appearance, shouldRenderToParent: shouldRenderToParent } = (0, $fiAWX.usePopupAppearance)({
        appearance: inAppearance,
        shouldRenderToParent: inShouldRenderToParent
    });
    const handleOpenLayerObserverCloseSignal = (0, $gwFzn.useCallback)(()=>{
        onClose?.(null);
    }, [
        onClose
    ]);
    (0, $if5rb.useNotifyOpenLayerObserver)({
        isOpen: isOpen,
        onClose: handleOpenLayerObserverCloseSignal
    });
    if (!isOpen) return null;
    const popperWrapper = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $iug2J.Layering), {
        isDisabled: false,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2cdko.default), {
            xcss: xcss,
            appearance: appearance,
            content: children,
            isOpen: isOpen,
            placement: placement,
            fallbackPlacements: fallbackPlacements,
            boundary: boundary,
            rootBoundary: rootBoundary,
            shouldFlip: shouldFlip,
            offset: offset,
            popupComponent: popupComponent,
            id: id,
            testId: testId,
            onClose: onClose,
            autoFocus: autoFocus,
            shouldFitContainer: shouldFitContainer,
            shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick,
            shouldRenderToParent: shouldRenderToParent,
            shouldDisableFocusLock: shouldDisableFocusLock,
            triggerRef: triggerRef,
            strategy: strategy,
            shouldFitViewport: shouldFitViewport,
            modifiers: shouldDisableGpuAcceleration ? $9aa4c7c29923f177$var$shouldDisableGpuAccelerationModifiers : undefined
        })
    });
    if (shouldRenderToParent) return popperWrapper;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $caX7N.default), {
        zIndex: zIndex,
        children: popperWrapper
    });
};

});


parcelRegister("580cg", function(module, exports) {

$parcel$export(module.exports, "FlyoutMenuItemContent", () => $1a686eeb6b8b51dd$export$2ca9a13c57a8839a);
/* flyout-menu-item-content.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $l5LHO = parcelRequire("l5LHO");

var $fFwtP = parcelRequire("fFwtP");
const $1a686eeb6b8b51dd$var$flyoutMenuItemContentStyles = {
    root: "_1q51u2gc _85i5u2gc _bozgu2gc _y4tiu2gc _14b51kdj"
};
const $1a686eeb6b8b51dd$export$2ca9a13c57a8839a = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ children: children, containerTestId: containerTestId, onClose: onClose, autoFocus: autoFocus }, forwardedRef)=>{
    const setIsOpen = (0, $gwFzn.useContext)((0, $fFwtP.SetIsOpenContext));
    const handleClose = (0, $gwFzn.useCallback)(()=>{
        onClose?.();
        setIsOpen(false);
    }, [
        setIsOpen,
        onClose
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $l5LHO.PopupContent), {
        appearance: "UNSAFE_modal-below-sm",
        onClose: handleClose,
        placement: "right-start",
        shouldFitViewport: true,
        testId: containerTestId,
        xcss: $1a686eeb6b8b51dd$var$flyoutMenuItemContentStyles.root,
        autoFocus: autoFocus,
        /**
   * Disabling GPU acceleration removes the use of `transform` by popper.js for this popup.
   *
   * This allows makers to use popups with `shouldRenderToParent` inside the flyout.
   *
   * Without this, the `transform` makes the flyout the containing element for fixed positioning.
   * Because the flyout is also a scroll container then any nested, layered element is unable to
   * escape the flyout.
   *
   * Disabling the `transform` is the simplest way to resolve this layering issue,
   * and should have negligible performance impacts, because the flyout menus should rarely
   * need to be repositioned.
   */ shouldDisableGpuAcceleration: true,
        children: ()=>/*#__PURE__*/ (0, $7UHDa.jsx)("div", {
                ref: forwardedRef,
                children: children
            })
    });
});

});

parcelRegister("f4c6t", function(module, exports) {

$parcel$export(module.exports, "FlyoutMenuItemTrigger", () => $666e8ec331d0ca1e$export$9f59f399fe37b6ca);
/* flyout-menu-item-trigger.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $3654r = parcelRequire("3654r");

var $6R5uz = parcelRequire("6R5uz");

var $l5LHO = parcelRequire("l5LHO");

var $5ujhR = parcelRequire("5ujhR");
const $666e8ec331d0ca1e$var$elemAfterStyles = {
    root: "_18zr12x7 _1tz3r0mg"
};
const $666e8ec331d0ca1e$export$9f59f399fe37b6ca = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ children: children, elemBefore: elemBefore, onClick: onClick, isSelected: isSelected, interactionName: interactionName, testId: testId, isContentTooltipDisabled: isContentTooltipDisabled, visualContentRef: visualContentRef, isDragging: isDragging, hasDragIndicator: hasDragIndicator, dropIndicator: dropIndicator }, forwardedRef)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $l5LHO.PopupTrigger), {
        children: ({ ref: ref, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup })=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $5ujhR.MenuItemBase), {
                testId: testId,
                ref: (0, $3654r.default)([
                    ref,
                    forwardedRef
                ]),
                visualContentRef: visualContentRef,
                elemBefore: elemBefore,
                elemAfter: /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
                    className: (0, $35pXk.default)([
                        $666e8ec331d0ca1e$var$elemAfterStyles.root
                    ]),
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6R5uz))), {
                        label: "",
                        color: "var(--ds-icon, #44546F)",
                        size: "small"
                    })
                }),
                onClick: onClick,
                ariaControls: ariaControls,
                ariaExpanded: ariaExpanded,
                ariaHasPopup: ariaHasPopup,
                interactionName: interactionName,
                isContentTooltipDisabled: isContentTooltipDisabled,
                isSelected: isSelected,
                isDragging: isDragging,
                hasDragIndicator: hasDragIndicator,
                dropIndicator: dropIndicator,
                children: children
            })
    }));

});

parcelRegister("b7uWl", function(module, exports) {

$parcel$export(module.exports, "MenuContent", () => $8a78adbc066f498f$export$479f0f2f71193efe);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $1Whri = parcelRequire("1Whri");

var $7hXDW = parcelRequire("7hXDW");

var $Rk8D3 = parcelRequire("Rk8D3");
var $6f0Oj = parcelRequire("6f0Oj");

var $i2sli = parcelRequire("i2sli");
const $8a78adbc066f498f$var$styles = {
    root: "_1e0c1txw _2lx21bp4 _c71l1x4w _18m91wug _19bvu2gc _u5f3u2gc",
    heading: "_1rjc12x7 _19bv12x7 _1e0c1txw _4cvr1h6o"
};
const $8a78adbc066f498f$export$479f0f2f71193efe = ({ children: children, heading: heading })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $Rk8D3.default), {
        xcss: (0, $1Whri.cx)($8a78adbc066f498f$var$styles.root),
        inline: "space.100",
        children: [
            heading && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                xcss: (0, $1Whri.cx)($8a78adbc066f498f$var$styles.heading),
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7hXDW.default), {
                    size: "xsmall",
                    as: "h2",
                    children: formatMessage((0, $i2sli.messages).sites, {
                        productName: heading
                    })
                })
            }),
            children
        ]
    });
};

});
parcelRegister("i2sli", function(module, exports) {

$parcel$export(module.exports, "messages", () => $f599cee8bd06af11$export$defe85febe8b728c);

var $2nPZH = parcelRequire("2nPZH");
const $f599cee8bd06af11$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    sites: {
        id: "navigation.global-shortcuts.sites",
        defaultMessage: "{productName} sites"
    }
});

});


parcelRegister("exCAi", function(module, exports) {

$parcel$export(module.exports, "fireMenuLinkItemClickAnalyticsEvent", () => $38975b5be28224a9$export$18a13ecc162cd5c2);
$parcel$export(module.exports, "MenuLinkItem", () => $38975b5be28224a9$export$68ef190193a37bc2);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $7TH2w = parcelRequire("7TH2w");

var $inPa6 = parcelRequire("inPa6");

var $1Whri = parcelRequire("1Whri");

var $8tdj3 = parcelRequire("8tdj3");

var $iI2ST = parcelRequire("iI2ST");

var $lujnM = parcelRequire("lujnM");

var $gdv5Z = parcelRequire("gdv5Z");

var $culkJ = parcelRequire("culkJ");

var $lAokq = parcelRequire("lAokq");

var $4FAyx = parcelRequire("4FAyx");

var $3t40Y = parcelRequire("3t40Y");
const $38975b5be28224a9$export$18a13ecc162cd5c2 = (createAnalyticsEvent, analyticsName)=>{
    createAnalyticsEvent({
        eventType: (0, $7TH2w.UI_EVENT_TYPE),
        action: 'clicked',
        actionSubject: 'button',
        actionSubjectId: 'globalNavigation',
        attributes: {
            name: analyticsName
        }
    }).fire((0, $culkJ.ANALYTICS_CHANNEL));
};
const $38975b5be28224a9$var$styles = {
    iconsBlock: "_18zr12x7"
}; // renders null if url is undefined, renders disabled if url is null but disabled is true, renders link item if url has a value
const $38975b5be28224a9$export$68ef190193a37bc2 = ({ analyticsName: analyticsName, url: url, label: label, icon: icon, disabled: disabled, onDisable: onDisable, ariaLabel: ariaLabel, loading: loading, actions: actions })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const onClick = (0, $gwFzn.useCallback)(()=>{
        $38975b5be28224a9$export$18a13ecc162cd5c2(createAnalyticsEvent, analyticsName);
    }, [
        createAnalyticsEvent,
        analyticsName
    ]); // If loading is true, we want to render a representation of the button
    if (loading === true) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $lAokq.MenuLoadingItem), {
        icon: icon,
        label: label,
        showLinkIcon: true
    });
     // Don't render anything if url is undefined or empty, and disabled is not explicitly set to true
    if ((!url || url === '') && !disabled) return null;
     // Render disabled items if no url and/or disabled is true
    if (!url || disabled) {
        if (!url || url === '') onDisable?.('Invalid URL');
        else onDisable?.();
        return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $iI2ST.ButtonMenuItem), {
            elemBefore: icon,
            isDisabled: true,
            children: [
                label,
                /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
                    "aria-label": formatMessage((0, $3t40Y.messages).disabledItemAriaLabel)
                })
            ]
        });
    }
    // Only render link item if url is defined
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $lujnM.LinkMenuItem), {
        actionsOnHover: actions && actions.length && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4FAyx.ShortcutActionMenu), {
            actions: actions
        }),
        elemBefore: icon,
        elemAfter: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
            xcss: (0, $1Whri.cx)($38975b5be28224a9$var$styles.iconsBlock),
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8tdj3))), {
                label: formatMessage((0, $3t40Y.messages).linkExternalIconLabel),
                size: "small"
            })
        }),
        href: url,
        target: "_blank",
        onClick: onClick,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
            "aria-label": ariaLabel,
            children: label
        })
    });
};

});
parcelRegister("lAokq", function(module, exports) {

$parcel$export(module.exports, "MenuLoadingItem", () => $c9a9a1032b23ec6d$export$6c62e509491f8f00);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $1Whri = parcelRequire("1Whri");

var $8tdj3 = parcelRequire("8tdj3");

var $iI2ST = parcelRequire("iI2ST");

var $gdv5Z = parcelRequire("gdv5Z");

var $9hlns = parcelRequire("9hlns");

var $h0fTc = parcelRequire("h0fTc");
const $c9a9a1032b23ec6d$var$styles = {
    iconsBlock: "_18zr12x7"
};
const $c9a9a1032b23ec6d$export$6c62e509491f8f00 = ({ icon: icon, label: label, showLinkIcon: showLinkIcon })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $iI2ST.ButtonMenuItem), {
        elemBefore: icon,
        elemAfter: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
            xcss: (0, $1Whri.cx)($c9a9a1032b23ec6d$var$styles.iconsBlock),
            children: showLinkIcon ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8tdj3))), {
                label: formatMessage((0, $h0fTc.messages).loadingItemAriaLabel),
                size: "small"
            }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9hlns.default), {
                size: "small"
            })
        }),
        testId: "menu-button-loading",
        children: [
            label,
            /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
                "aria-label": formatMessage((0, $h0fTc.messages).loadingItemAriaLabel)
            })
        ]
    });
};

});
parcelRegister("h0fTc", function(module, exports) {

$parcel$export(module.exports, "messages", () => $120bf42293d1fba3$export$defe85febe8b728c);

var $2nPZH = parcelRequire("2nPZH");
const $120bf42293d1fba3$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    loadingItemAriaLabel: {
        id: "navigation.global-shortcuts.menu-loading-item.loading-item-aria-label",
        defaultMessage: "(loading)"
    }
});

});


parcelRegister("4FAyx", function(module, exports) {

$parcel$export(module.exports, "ShortcutActionMenu", () => $d6eb3e10d21d0abb$export$7e648395389e18b0);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $1qfLF = parcelRequire("1qfLF");

var $g5gZt = parcelRequire("g5gZt");

var $56M4r = parcelRequire("56M4r");
var $2SlZp = parcelRequire("2SlZp");

var $lGgRw = parcelRequire("lGgRw");

var $gzXTE = parcelRequire("gzXTE");
const $d6eb3e10d21d0abb$export$7e648395389e18b0 = ({ actions: actions })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const [isOpen, setIsOpen] = (0, $gwFzn.useState)(false);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $lGgRw.Popup), {
        shouldRenderToParent: true,
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        placement: "bottom-start",
        content: ()=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $2SlZp.default), {
                children: actions.map((action, index)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $56M4r.default), {
                        onClick: (e)=>{
                            e.preventDefault();
                            action.onClick?.();
                            setIsOpen(false);
                        },
                        children: action.component
                    }, index))
            }),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $1qfLF.default), {
                ...triggerProps,
                appearance: "subtle",
                spacing: "compact",
                icon: (props)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($g5gZt))), {
                        ...props,
                        size: "small"
                    }),
                label: formatMessage((0, $gzXTE.messages).shortcutActionOpenMenuLabel),
                onClick: ()=>setIsOpen(true)
            })
    });
};

});
parcelRegister("gzXTE", function(module, exports) {

$parcel$export(module.exports, "messages", () => $bae1ab3d84e6d86e$export$defe85febe8b728c);

var $2nPZH = parcelRequire("2nPZH");
const $bae1ab3d84e6d86e$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    shortcutActionOpenMenuLabel: {
        id: "navigation.global-shortcuts.shortcut-action.open-menu-label",
        defaultMessage: "open menu"
    }
});

});


parcelRegister("3t40Y", function(module, exports) {

$parcel$export(module.exports, "messages", () => $d7199daead2261d0$export$defe85febe8b728c);

var $2nPZH = parcelRequire("2nPZH");
const $d7199daead2261d0$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    disabledItemAriaLabel: {
        id: "navigation.global-shortcuts.menu-link-item.disabled-item-aria-label",
        defaultMessage: "(currently unavailable)"
    },
    loadingItemAriaLabel: {
        id: "navigation.global-shortcuts.menu-link-item.loading-item-aria-label",
        defaultMessage: "(loading)"
    },
    linkExternalIconLabel: {
        id: "navigation.global-shortcuts.menu-link-item.link-external-item-label",
        defaultMessage: "Open external link icon"
    }
});

});


parcelRegister("89S1K", function(module, exports) {

$parcel$export(module.exports, "MenuSection", () => $2059564238074a0d$export$4b1545b4f2016d26);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $1Whri = parcelRequire("1Whri");

var $6f0Oj = parcelRequire("6f0Oj");
var $bUlM5 = parcelRequire("bUlM5");
const $2059564238074a0d$var$styles = {
    heading: "_11c82smr _1rjcu2gc _19bv12x7 _ca0qu2gc _n3tdu2gc _syaz1gjq _k48p1pd9 _1e0c1txw _4cvr1h6o"
};
const $2059564238074a0d$export$4b1545b4f2016d26 = ({ children: children, label: label })=>{
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $bUlM5.default), {
        direction: "column",
        children: [
            label && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                xcss: (0, $1Whri.cx)($2059564238074a0d$var$styles.heading),
                children: label
            }),
            children
        ]
    });
};

});

parcelRegister("l4OFZ", function(module, exports) {

$parcel$export(module.exports, "messages", () => $95a126794c4e4163$export$defe85febe8b728c);

var $2nPZH = parcelRequire("2nPZH");
const $95a126794c4e4163$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    allSites: {
        id: "navigation.global-shortcuts.all-sites",
        defaultMessage: "All sites"
    },
    closeButtonAriaLabel: {
        id: "navigation.global-shortcuts.menu-expand-item.close-button-aria-label",
        defaultMessage: "Close"
    },
    siteAriaLabel: {
        id: "navigation.global-shortcuts.menu-expand-item.site-aria-label",
        defaultMessage: "{name} site"
    }
});

});


parcelRegister("gSkPq", function(module, exports) {

$parcel$export(module.exports, "messages", () => $7614326872455d2b$export$defe85febe8b728c);

var $2nPZH = parcelRequire("2nPZH");
const $7614326872455d2b$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    menuLinkItemAriaLabel: {
        id: "navigation.global-shortcuts.shortcut-link-item.aria-label",
        defaultMessage: "{appName}{siteName}"
    }
});

});



parcelRegister("k3207", function(module, exports) {

$parcel$export(module.exports, "productLinksWorkspaceCloudIdFilter", () => $c124c8c0b6cfb1b3$export$54a1da5292674ec8);
const $c124c8c0b6cfb1b3$export$54a1da5292674ec8 = (workspaceCloudId)=>(item, index, arr)=>{
        const matchedItem = arr.find((productLink)=>{
            return productLink.cloudId === workspaceCloudId;
        });
        // If an item exists in the parent array with the same cloudId,
        // we don't want to show a flyout and instead only want the list
        // of available product links to include the matching cloudId.
        if (matchedItem) return workspaceCloudId === item.cloudId;
        // If the filter gets here we want to only pass the first item
        return index === 0;
    };

});

parcelRegister("7jA14", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a42c6aaec7538b2$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $5GHmV = parcelRequire("5GHmV");

var $j5xUq = parcelRequire("j5xUq");
function $5a42c6aaec7538b2$export$2e2bcd8739ae039(fallbackUrl, label) {
    return {
        icon: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5GHmV.CompanyHubIcon), {
            size: "20"
        }),
        label: label ?? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
            ...(0, $j5xUq.messages).label
        }),
        fallbackUrl: fallbackUrl
    };
}

});
parcelRegister("j5xUq", function(module, exports) {

$parcel$export(module.exports, "messages", () => $82db327e56ac3de4$export$defe85febe8b728c);

var $2nPZH = parcelRequire("2nPZH");
const $82db327e56ac3de4$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    label: {
        id: "navigation.global-shortcuts.apps.company-hub",
        defaultMessage: "Company Hub"
    }
});

});


parcelRegister("12t1c", function(module, exports) {

$parcel$export(module.exports, "default", () => $e306a0f1948559b4$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $g1L9J = parcelRequire("g1L9J");

var $culkJ = parcelRequire("culkJ");

var $iQBG4 = parcelRequire("iQBG4");
function $e306a0f1948559b4$export$2e2bcd8739ae039(fallbackUrl) {
    return {
        icon: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $g1L9J.JiraIcon), {
            size: "20"
        }),
        label: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
            ...(0, $iQBG4.messages).label
        }),
        apsKey: (0, $culkJ.Products).JIRA_SOFTWARE,
        fallbackUrl: fallbackUrl
    };
}

});
parcelRegister("iQBG4", function(module, exports) {

$parcel$export(module.exports, "messages", () => $614604228efdb790$export$defe85febe8b728c);

var $2nPZH = parcelRequire("2nPZH");
const $614604228efdb790$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    label: {
        id: "navigation.global-shortcuts.apps.jira",
        defaultMessage: "Jira"
    }
});

});


parcelRegister("aZVNi", function(module, exports) {

$parcel$export(module.exports, "default", () => $4898362ef69c915e$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $741y4 = parcelRequire("741y4");

var $culkJ = parcelRequire("culkJ");

var $8ksfD = parcelRequire("8ksfD");
function $4898362ef69c915e$export$2e2bcd8739ae039(fallbackUrl) {
    return {
        icon: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $741y4.LoomIcon), {
            size: "20"
        }),
        label: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
            ...(0, $8ksfD.messages).label
        }),
        apsKey: (0, $culkJ.Products).LOOM,
        fallbackUrl: fallbackUrl
    };
}

});
parcelRegister("8ksfD", function(module, exports) {

$parcel$export(module.exports, "messages", () => $e96a79584135f443$export$defe85febe8b728c);

var $2nPZH = parcelRequire("2nPZH");
const $e96a79584135f443$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    label: {
        id: "navigation.global-shortcuts.apps.loom",
        defaultMessage: "Loom"
    }
});

});


parcelRegister("GEjfy", function(module, exports) {

$parcel$export(module.exports, "default", () => $3dab1474f6c2c995$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $eZovf = parcelRequire("eZovf");

var $culkJ = parcelRequire("culkJ");

var $1EsaG = parcelRequire("1EsaG");
function $3dab1474f6c2c995$export$2e2bcd8739ae039(fallbackUrl) {
    return {
        icon: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $eZovf.TeamsIcon), {
            size: "20"
        }),
        label: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
            ...(0, $1EsaG.messages).label
        }),
        apsKey: (0, $culkJ.Products).ATLAS_TEAMS,
        fallbackUrl: fallbackUrl
    };
}

});
parcelRegister("1EsaG", function(module, exports) {

$parcel$export(module.exports, "messages", () => $6e45175315a8a66e$export$defe85febe8b728c);

var $2nPZH = parcelRequire("2nPZH");
const $6e45175315a8a66e$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    label: {
        id: "navigation.global-shortcuts.apps.teams",
        defaultMessage: "Teams"
    }
});

});


parcelRegister("5OTt8", function(module, exports) {

$parcel$export(module.exports, "useOrderedAppShortcuts", () => $f7c408d2cea2cf45$export$4bb4a114d280c175);

var $gwFzn = parcelRequire("gwFzn");
const $f7c408d2cea2cf45$export$4bb4a114d280c175 = (shortcutItemsConfig, orderedMenuConfig)=>{
    return (0, $gwFzn.useMemo)(()=>{
        if (!orderedMenuConfig || orderedMenuConfig.length === 0) return Object.values(shortcutItemsConfig);
        return orderedMenuConfig.reduce((acc, value)=>{
            const config = shortcutItemsConfig[value.menuId];
            if (config && value.visible) acc.push(config);
            return acc;
        }, []);
    }, [
        shortcutItemsConfig,
        orderedMenuConfig
    ]);
};

});

parcelRegister("hwR8R", function(module, exports) {

$parcel$export(module.exports, "VisuallyHiddenDivider", () => $0ee6c989351c091a$export$5e38ec3cfec73955);
/* VisuallyHiddenDivider.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $35pXk = parcelRequire("35pXk");

var $gwFzn = parcelRequire("gwFzn");
const $0ee6c989351c091a$export$5e38ec3cfec73955 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("hr", {
        role: "presentation",
        className: (0, $35pXk.default)([
            "_19itidpf _1mou12x7 _3um015vq"
        ])
    });
const $0ee6c989351c091a$var$dividerStyles = null;

});


parcelRegister("3z2Im", function(module, exports) {

$parcel$export(module.exports, "MoreMenuItem", () => $6bf303f52478ae0b$export$e967513bbeba0537);

var $gwFzn = parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $l5LHO = parcelRequire("l5LHO");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $iI2ST = parcelRequire("iI2ST");

var $lujnM = parcelRequire("lujnM");

var $iZRoG = parcelRequire("iZRoG");

var $9wGTI = parcelRequire("9wGTI");

var $63PsI = parcelRequire("63PsI");

var $6bH0k = parcelRequire("6bH0k");

var $1LksZ = parcelRequire("1LksZ");

var $cxU8R = parcelRequire("cxU8R");
const $6bf303f52478ae0b$export$e967513bbeba0537 = ({ moreMenuItems: moreMenuItems, isOpen: isOpen, toggleMenu: toggleMenu, onClick: onClick, peekingId: peekingId })=>{
    const companyHubName = (0, $63PsI.useCompanyHubName)();
    if (!moreMenuItems || moreMenuItems?.length <= 0) return null;
    const popup = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $l5LHO.Popup), {
        isOpen: isOpen
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $l5LHO.PopupTrigger), null, (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $iI2ST.ButtonMenuItem), {
            ...triggerProps,
            elemBefore: (0, $cxU8R.MoreIconComponent),
            onClick: toggleMenu
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), (0, $1LksZ.i18n).more))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $6bf303f52478ae0b$var$popupContentContainerStyles,
        role: "listitem"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $l5LHO.PopupContent), {
        placement: "bottom-start",
        // Offset the top margin of the menu section.
        // This will keep an even spacing of menu items between those inside the dropdown and those above,
        // and keep the icons aligned
        offset: [
            -4,
            4
        ],
        onClose: toggleMenu,
        shouldRenderToParent: true,
        strategy: "absolute",
        shouldFitContainer: true
    }, ()=>{
        // The number of visible / non-null menu items so that proper dividers can be added.
        let nonNullMenuItemCount = 0;
        const menuItems = moreMenuItems.map(({ menuId: menuId, href: href, isAppShortcut: isAppShortcut })=>{
            if (peekingId && menuId === peekingId) return null; //if an item is peeking, do not render it in this menu
            ++nonNullMenuItemCount;
            if (menuId === 'companyHub') {
                const Component = (0, $6bH0k.GlobalItemLoadables)[menuId];
                if (Component) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, nonNullMenuItemCount !== 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $iZRoG.Divider), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
                    xcss: $6bf303f52478ae0b$var$menuItemStyles
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(Component, {
                    key: menuId,
                    onClick: ()=>onClick(menuId),
                    setIsCustomizeSidebarDialogVisible: ()=>{}
                })));
            }
            let node;
            if (href) node = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lujnM.LinkMenuItem), {
                href: href,
                onClick: ()=>onClick(menuId),
                elemBefore: (0, $cxU8R.iconByMenuId)[menuId],
                key: menuId,
                target: isAppShortcut ? '_blank' : undefined
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
                ...(0, $1LksZ.i18n)[menuId],
                values: menuId === 'companyHubShortcut' ? {
                    companyHubName: companyHubName
                } : {}
            }));
            else node = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $iI2ST.ButtonMenuItem), {
                onClick: ()=>onClick(menuId),
                elemBefore: (0, $cxU8R.iconByMenuId)[menuId],
                key: menuId
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
                ...(0, $1LksZ.i18n)[menuId],
                values: menuId === 'companyHubShortcut' ? {
                    companyHubName: companyHubName
                } : {}
            }));
            // The item "Customize sidebar" is visually divided from the preceeding global items and/or app shortcuts:
            if (node && (0, $9wGTI.fg)('company-hub-pseudo-app')) {
                node = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
                    xcss: $6bf303f52478ae0b$var$menuItemStyles
                }, node);
                if (nonNullMenuItemCount !== 1 && menuId === 'customize') node = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $iZRoG.Divider), null), node);
            }
            return node;
        });
        if ((0, $9wGTI.fg)('company-hub-pseudo-app')) // PopupContent has an `xcss` prop, but it casts its value to `string` and thus isn't suitable.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
            xcss: $6bf303f52478ae0b$var$popupContentStyles
        }, menuItems);
        return menuItems;
    })));
    return popup;
};
const $6bf303f52478ae0b$var$popupContentContainerStyles = (0, $ecnYn.xcss)({
    position: 'relative',
    marginInline: 'space.negative.050',
    height: '0'
});
const $6bf303f52478ae0b$var$popupContentStyles = (0, $ecnYn.xcss)({
    paddingTop: 'space.050',
    paddingBottom: 'space.050'
});
const $6bf303f52478ae0b$var$menuItemStyles = (0, $ecnYn.xcss)({
    paddingLeft: 'space.050',
    paddingRight: 'space.050'
});

});
parcelRegister("1LksZ", function(module, exports) {

$parcel$export(module.exports, "i18n", () => $135393dc762a6338$export$a7357cdd1f0b0168);

var $2nPZH = parcelRequire("2nPZH");
const $135393dc762a6338$export$a7357cdd1f0b0168 = (0, $2nPZH.defineMessages)({
    customHome: {
        id: "side-navigation.global.home",
        defaultMessage: "Home"
    },
    forYou: {
        id: "side-navigation.global.for.you",
        defaultMessage: "For you"
    },
    yourWork: {
        id: "side-navigation.global.your.work",
        defaultMessage: "For you"
    },
    companyHub: {
        id: "side-navigation.global.company.hub",
        defaultMessage: "Company Hub"
    },
    recent: {
        id: "side-navigation.global.recent",
        defaultMessage: "Recent"
    },
    starred: {
        id: "side-navigation.global.starred",
        defaultMessage: "Starred"
    },
    spaces: {
        id: "side-navigation.global.spaces",
        defaultMessage: "Spaces"
    },
    apps: {
        id: "side-navigation.global.apps",
        defaultMessage: "Apps"
    },
    goals: {
        id: "side-navigation.global.goals",
        defaultMessage: "Goals"
    },
    topics: {
        id: "side-navigation.global.topics",
        defaultMessage: "Topics"
    },
    teams: {
        id: "side-navigation.global.teams",
        defaultMessage: "Teams"
    },
    drafts: {
        id: "side-navigation.global.drafts",
        defaultMessage: "Drafts"
    },
    tasks: {
        id: "side-navigation.global.tasks",
        defaultMessage: "Tasks"
    },
    more: {
        id: "side-navigation.global.more",
        defaultMessage: "More"
    },
    customize: {
        id: "side-navigation.global.customize.sidebar",
        defaultMessage: "Customize sidebar"
    },
    templates: {
        id: "side-navigation.global.customize.templates",
        defaultMessage: "Templates"
    },
    workflows: {
        id: "side-navigation.global.customize.workflows",
        defaultMessage: "Workflows"
    },
    separator: {
        id: "side-navigation.global.customize.separator",
        defaultMessage: "HIDE FROM SIDEBAR"
    },
    jiraShortcut: {
        id: "side-navigation.global.customize.jiraShortcut",
        defaultMessage: "Jira"
    },
    loomShortcut: {
        id: "side-navigation.global.customize.loomShortcut",
        defaultMessage: "Loom"
    },
    teamsShortcut: {
        id: "side-navigation.global.customize.teamsShortcut",
        defaultMessage: "Teams"
    },
    companyHubShortcut: {
        id: "side-navigation.global.customize.companyHubShortcut",
        defaultMessage: "{companyHubName}"
    }
});

});

parcelRegister("cxU8R", function(module, exports) {

$parcel$export(module.exports, "ForYouIconComponent", () => $b1654aa018846a1e$export$4370213f5e13a087);
$parcel$export(module.exports, "HomeIconComponent", () => $b1654aa018846a1e$export$fcf3ce494c961537);
$parcel$export(module.exports, "OfficeIconComponent", () => $b1654aa018846a1e$export$e25b0b35bcc6a6f4);
$parcel$export(module.exports, "ClockIconComponent", () => $b1654aa018846a1e$export$22eb82a2d06386cd);
$parcel$export(module.exports, "StarIconComponent", () => $b1654aa018846a1e$export$e354edba2d87a80b);
$parcel$export(module.exports, "GlobeIconComponent", () => $b1654aa018846a1e$export$815068847a2940cc);
$parcel$export(module.exports, "AppsIconComponent", () => $b1654aa018846a1e$export$2ad8d00357381dab);
$parcel$export(module.exports, "GoalIconComponent", () => $b1654aa018846a1e$export$b8743c92b35ba3d2);
$parcel$export(module.exports, "HashIconComponent", () => $b1654aa018846a1e$export$ea1e8de44637bcc8);
$parcel$export(module.exports, "TeamsIconComponent", () => $b1654aa018846a1e$export$85b08d1fd6c3c91e);
$parcel$export(module.exports, "EditIconComponent", () => $b1654aa018846a1e$export$3ac9d636aeac90b);
$parcel$export(module.exports, "TaskIconComponent", () => $b1654aa018846a1e$export$44d9bde334d7e007);
$parcel$export(module.exports, "TemplatesIconComponent", () => $b1654aa018846a1e$export$296eedab7746f8f0);
$parcel$export(module.exports, "MoreIconComponent", () => $b1654aa018846a1e$export$1f926db0b8c551ab);
$parcel$export(module.exports, "WorkflowsIconComponent", () => $b1654aa018846a1e$export$3fe190d7e217797d);
$parcel$export(module.exports, "CustomizeIconComponent", () => $b1654aa018846a1e$export$553a8f8e72a63c41);
$parcel$export(module.exports, "iconByMenuId", () => $b1654aa018846a1e$export$803815ff2adecad4);

var $gwFzn = parcelRequire("gwFzn");

var $4wwVl = parcelRequire("4wwVl");

var $fJM5Q = parcelRequire("fJM5Q");

var $ctmPb = parcelRequire("ctmPb");

var $kevJM = parcelRequire("kevJM");

var $kfYj7 = parcelRequire("kfYj7");

var $buthI = parcelRequire("buthI");

var $tvI67 = parcelRequire("tvI67");

var $gJsgh = parcelRequire("gJsgh");

var $la4Nn = parcelRequire("la4Nn");

var $1dKyn = parcelRequire("1dKyn");

var $1Zr9M = parcelRequire("1Zr9M");

var $dmbve = parcelRequire("dmbve");

var $9VJDA = parcelRequire("9VJDA");

var $gXn1S = parcelRequire("gXn1S");

var $33kXB = parcelRequire("33kXB");

var $isYda = parcelRequire("isYda");

var $5GHmV = parcelRequire("5GHmV");

var $g1L9J = parcelRequire("g1L9J");

var $741y4 = parcelRequire("741y4");

var $eZovf = parcelRequire("eZovf");
const $b1654aa018846a1e$var$StyledIconComponent = /*#__PURE__*/ (0, $gwFzn.memo)(({ icon: icon, testId: testId })=>{
    const IconComponent = icon;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(IconComponent, {
        label: "",
        color: "currentColor",
        spacing: "spacious",
        testId: testId
    });
});
const $b1654aa018846a1e$export$4370213f5e13a087 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($b1654aa018846a1e$var$StyledIconComponent, {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($4wwVl))),
    testId: "global-nav-for-you-icon-temp-do-not-use"
});
const $b1654aa018846a1e$export$fcf3ce494c961537 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($b1654aa018846a1e$var$StyledIconComponent, {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($fJM5Q))),
    testId: "global-nav-home-icon-temp-do-not-use"
});
const $b1654aa018846a1e$export$e25b0b35bcc6a6f4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($b1654aa018846a1e$var$StyledIconComponent, {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($ctmPb))),
    testId: "global-nav-office-icon-temp-do-not-use"
});
const $b1654aa018846a1e$export$22eb82a2d06386cd = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($b1654aa018846a1e$var$StyledIconComponent, {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($kevJM))),
    testId: "global-nav-clock-icon-temp-do-not-use"
});
const $b1654aa018846a1e$export$e354edba2d87a80b = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($b1654aa018846a1e$var$StyledIconComponent, {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($kfYj7))),
    testId: "global-nav-star-icon-temp-do-not-use"
});
const $b1654aa018846a1e$export$815068847a2940cc = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($b1654aa018846a1e$var$StyledIconComponent, {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($buthI))),
    testId: "global-nav-globe-icon-temp-do-not-use"
});
const $b1654aa018846a1e$export$2ad8d00357381dab = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($b1654aa018846a1e$var$StyledIconComponent, {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($tvI67))),
    testId: "global-nav-apps-icon-temp-do-not-use"
});
const $b1654aa018846a1e$export$b8743c92b35ba3d2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($b1654aa018846a1e$var$StyledIconComponent, {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($gJsgh))),
    testId: "global-nav-goal-icon-temp-do-not-use"
});
const $b1654aa018846a1e$export$ea1e8de44637bcc8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($b1654aa018846a1e$var$StyledIconComponent, {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($la4Nn))),
    testId: "global-nav-hash-icon-temp-do-not-use"
});
const $b1654aa018846a1e$export$85b08d1fd6c3c91e = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($b1654aa018846a1e$var$StyledIconComponent, {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($1dKyn))),
    testId: "global-nav-teams-icon-temp-do-not-use"
});
const $b1654aa018846a1e$export$3ac9d636aeac90b = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($b1654aa018846a1e$var$StyledIconComponent, {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($1Zr9M))),
    testId: "global-nav-edit-icon-temp-do-not-use"
});
const $b1654aa018846a1e$export$44d9bde334d7e007 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($b1654aa018846a1e$var$StyledIconComponent, {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($dmbve))),
    testId: "global-nav-task-icon-temp-do-not-use"
});
const $b1654aa018846a1e$export$296eedab7746f8f0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($b1654aa018846a1e$var$StyledIconComponent, {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($gXn1S))),
    testId: "global-nav-templates-icon-temp-do-not-use"
});
const $b1654aa018846a1e$export$1f926db0b8c551ab = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($b1654aa018846a1e$var$StyledIconComponent, {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))),
    testId: "global-nav-more-icon-temp-do-not-use"
});
const $b1654aa018846a1e$export$3fe190d7e217797d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($b1654aa018846a1e$var$StyledIconComponent, {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($33kXB))),
    testId: "global-nav-workflows-icon-temp-do-not-use"
});
const $b1654aa018846a1e$export$553a8f8e72a63c41 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($b1654aa018846a1e$var$StyledIconComponent, {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($isYda))),
    testId: "global-nav-customize-icon-temp-do-not-use"
});
const $b1654aa018846a1e$export$7ef71e75b22027b6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($b1654aa018846a1e$var$StyledIconComponent, {
    icon: (0, $5GHmV.CompanyHubIcon),
    testId: "global-nav-company-hub-icon-temp-do-not-use"
});
const $b1654aa018846a1e$export$b98c953fd1e726cc = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($b1654aa018846a1e$var$StyledIconComponent, {
    icon: (0, $eZovf.TeamsIcon),
    testId: "global-nav-new-teams-icon-temp-do-not-use"
});
const $b1654aa018846a1e$export$7ac757a6aec752f4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($b1654aa018846a1e$var$StyledIconComponent, {
    icon: (0, $g1L9J.JiraIcon),
    testId: "global-nav-jira-icon-temp-do-not-use"
});
const $b1654aa018846a1e$export$6e55f825f45b7145 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($b1654aa018846a1e$var$StyledIconComponent, {
    icon: (0, $741y4.LoomIcon),
    testId: "global-nav-loom-icon-temp-do-not-use"
});
const $b1654aa018846a1e$export$803815ff2adecad4 = {
    customHome: $b1654aa018846a1e$export$fcf3ce494c961537,
    yourWork: $b1654aa018846a1e$export$4370213f5e13a087,
    companyHub: $b1654aa018846a1e$export$e25b0b35bcc6a6f4,
    recent: $b1654aa018846a1e$export$22eb82a2d06386cd,
    starred: $b1654aa018846a1e$export$e354edba2d87a80b,
    spaces: $b1654aa018846a1e$export$815068847a2940cc,
    apps: $b1654aa018846a1e$export$2ad8d00357381dab,
    goals: $b1654aa018846a1e$export$b8743c92b35ba3d2,
    topics: $b1654aa018846a1e$export$ea1e8de44637bcc8,
    teams: $b1654aa018846a1e$export$85b08d1fd6c3c91e,
    drafts: $b1654aa018846a1e$export$3ac9d636aeac90b,
    tasks: $b1654aa018846a1e$export$44d9bde334d7e007,
    templates: $b1654aa018846a1e$export$296eedab7746f8f0,
    workflows: $b1654aa018846a1e$export$3fe190d7e217797d,
    customize: $b1654aa018846a1e$export$553a8f8e72a63c41,
    companyHubShortcut: $b1654aa018846a1e$export$7ef71e75b22027b6,
    teamsShortcut: $b1654aa018846a1e$export$b98c953fd1e726cc,
    jiraShortcut: $b1654aa018846a1e$export$7ac757a6aec752f4,
    loomShortcut: $b1654aa018846a1e$export$6e55f825f45b7145
};

});


parcelRegister("a2g1f", function(module, exports) {

let $74e684564b9381e8$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $74e684564b9381e8$var$load("1hbKG"),
    $74e684564b9381e8$var$load("i2OFv"),
    $74e684564b9381e8$var$load("39SPy"),
    $74e684564b9381e8$var$load("4PppF"),
    $74e684564b9381e8$var$load("31yDC"),
    $74e684564b9381e8$var$load("6XoCv"),
    $74e684564b9381e8$var$load("3kUQf"),
    $74e684564b9381e8$var$load("5mHIu"),
    $74e684564b9381e8$var$load("8DoxJ"),
    $74e684564b9381e8$var$load("ffEVr"),
    $74e684564b9381e8$var$load("dd7kC"),
    $74e684564b9381e8$var$load("joJy8"),
    $74e684564b9381e8$var$load("aHE9G"),
    $74e684564b9381e8$var$load("borwc")
]).then(()=>parcelRequire('jhdHU'));

});

parcelRegister("f7Mww", function(module, exports) {

let $b02d263affd1e44d$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $b02d263affd1e44d$var$load("1hbKG"),
    $b02d263affd1e44d$var$load("i2OFv"),
    $b02d263affd1e44d$var$load("31yDC"),
    $b02d263affd1e44d$var$load("aFS1j"),
    $b02d263affd1e44d$var$load("ffEVr"),
    $b02d263affd1e44d$var$load("8DoxJ"),
    $b02d263affd1e44d$var$load("dd7kC"),
    $b02d263affd1e44d$var$load("joJy8"),
    $b02d263affd1e44d$var$load("aHE9G"),
    $b02d263affd1e44d$var$load("1VNI4")
]).then(()=>parcelRequire('hC2RX'));

});

parcelRegister("gtSas", function(module, exports) {

let $bff95f59343f9ec1$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $bff95f59343f9ec1$var$load("SepNY").then(()=>parcelRequire('3QuUN'));

});



//# sourceMappingURL=GlobalNavigationComponent.87dd0c6f.js.map
